import { Translations } from '../models';

const getTranslations = <T extends Translations>(translations: T): T => translations;

export const TRANSLATIONS = getTranslations({
    'snackbar': {
        'info': {
            'loadInertiaEnteredValueTooHigh': [
                'The entered value is too high. The value will be reduced to the allowed maximum value.',
                'Eingetragene Zahl ist zu groß. Sie wird auf den maximal zulässigen Wert begrenzt.',
                'El número introducido es demasiado grande. Se limitará al valor máximo admisible.',
                'Le nombre saisi est trop grand. Il est limité à la valeur maximale admissible.',
                'Il numero inserito è troppo grande. Verrà limitato al valore massimo consentito.',
                'Número registado é demasiado elevado. Este é limitado ao valor máximo permitido.',
                '输入的值过大。该值将被允许范围内的最大值替换。',
                'Girilen sayı aşırı büyük. İzin verilen azami değerle sınırlandı.',
                'Ingegeven getal is te groot. Ze wordt tot de max. toegelaten waarde begrensd.',
                'Wprowadzona wartość jest za wysoka. Zostanie ona zmniejszona do dopuszczalnej wartości maksymalnej.',
                'Zadané číslo je příliš vysoké. Jste omezeni na maximální přípustnou hodnotu.'
            ],
            'loadInertiaValueTooHigh': [
                'The value is too high. The value will be reduced to the allowed maximum value.',
                'Zahl ist zu groß. Sie wird auf den maximal zulässigen Wert begrenzt.',
                'El número es demasiado grande. Se limitará al valor máximo admisible.',
                'Le nombre est trop grand. Il est limité à la valeur maximale admissible.',
                'Il numero è troppo grande. Verrà limitato al valore massimo consentito.',
                'O número é demasiado elevado. Este é limitado ao valor máximo permitido.',
                '数值过大。该值将被允许范围内的最大值替换。',
                'Sayı aşırı büyük. İzin verilen azami değerle sınırlandı.',
                'Getal is te groot. Ze wordt tot de max. toegelaten waarde begrensd.',
                'Wartość jest za wysoka. Zostanie ona zmniejszona do dopuszczalnej wartości maksymalnej.',
                'Číslo je příliš vysoké. Jste omezeni na maximální přípustnou hodnotu.'
            ],
            'n2TooHigh': [
                'n2 [rpm] (gearbox and load)',
                'n2 [1/min] (Getriebe und Last)',
                'n2 [1/min] (reductor y carga)',
                'n2 [tr/min] (réducteur et charge)',
                'n2 [1/min] (riduttore e carico)',
                'n2 [1/min] (engrenagem e carga)',
                'n2 [rpm]（齿轮箱和负载）',
                'n2 [1/dak] (dişli ve yük)',
                'n2 [1/min] (Transmissie en last)',
                'n2 [1/min] (przekładnia i obciążenie)',
                'n2 [ot/min] (převodovka a zátěž)'
            ],
            'n2EnteredValueTooHigh': [
                'The entered value is too high. The value will be reduced to the max. allowed value.',
                'Eingetragene Zahl ist zu groß. Sie wird auf den max. zulässigen Wert begrenzt!',
                'El número introducido es demasiado grande. ¡Se limitará al valor máx. admisible!',
                'Le nombre saisi est trop grand. Il est limité à la valeur max. admissible !',
                'Il numero inserito è troppo grande. Verrà limitato al valore massimo consentito!',
                'Número registado é demasiado elevado. Este é limitado ao valor máximo permitido!',
                '输入的值过大。该值将被允许范围内的最大值替换。',
                'Girilen sayı aşırı büyük. İzin verilen azami değerle sınırlandı!',
                'Ingegeven getal is te groot. Ze wordt tot de max. toegelaten waarde begrensd!',
                'Wprowadzona wartość jest za wysoka. Zostanie ona zmniejszona do maks. dopuszczalnej wartości.',
                'Zadané číslo je příliš vysoké. Jste omezeni na max. přípustnou hodnotu!'
            ],
            'n2TooLow': [
                'n2 [rpm] (gearbox and load)',
                'n2 [1/min] (Getriebe und Last)',
                'n2 [1/min] (reductor y carga)',
                'n2 [tr/min] (réducteur et charge)',
                'n2 [1/min] (riduttore e carico)',
                'n2 [1/min] (engrenagem e carga)',
                'n2 [rpm]（齿轮箱和负载）',
                'n2 [1/dak] (dişli ve yük)',
                'n2 [1/min] (Transmissie en last)',
                'n2 [1/min] (przekładnia i obciążenie)',
                'n2 [ot/min] (převodovka a zátěž)'
            ],
            'n2EnteredValueTooLow': [
                'The entered value is too low. The value will be set on the min. value.',
                'Eingetragene Zahl ist zu klein. Sie wird auf den min. Wert gesetzt.',
                'El número introducido es demasiado pequeño. Se ajustará al valor mín.',
                'Le nombre saisi est trop petit. Il est réglé à la valeur min.',
                'Il numero inserito è troppo piccolo. Verrà impostato al valore minimo.',
                'Número registado é demasiado pequeno. Este é definido para o valor mínimo!',
                '输入的值过小。该值将被允许范围内的最小值替换。',
                'Girilen sayı aşırı küçük. İzin verilen asgari değere getirildi.',
                'Ingevuld getal is te klein. Ze wordt op de min. waarde ingesteld.',
                'Wprowadzona wartość jest za niska. Zostanie ona ustawiona na wartość minimalną.',
                'Zadané číslo je příliš nízké. Dosadí se min. hodnota.'
            ],
            'gearboxInertiaTooHigh': [
                'Gearbox moment of inertia',
                'Trägheitsmoment des Getriebes',
                'Momento de inercia del reductor',
                'Moment d\'inertie du réducteur',
                'Momento d\'inerzia del riduttore',
                'Binário de inércia da engrenagem',
                '齿轮箱转动惯量',
                'Dişlinin eylemsizlik momenti',
                'Traagheidsmoment van de transmissie',
                'Moment bezwładności przekładni',
                'Moment setrvačnosti převodovky'
            ],
            'gearboxInertiaEnteredValueTooHigh': [
                'The entered value is too high. The value will be reduced to the max. allowed value.',
                'Eingetragene Zahl ist zu groß. Sie wird auf den max. zulässigen Wert begrenzt.',
                'El número introducido es demasiado grande. ¡Se limitará al valor máx. admisible!',
                'Le nombre saisi est trop grand. Il est limité à la valeur max. admissible !',
                'Il numero inserito è troppo grande. Verrà limitato al valore massimo consentito!',
                'Número registado é demasiado elevado. Este é limitado ao valor máximo permitido!',
                '输入的值过大。该值将被允许范围内的最大值替换。',
                'Girilen sayı aşırı büyük. İzin verilen azami değerle sınırlandı!',
                'Ingegeven getal is te groot. Ze wordt tot de max. toegelaten waarde begrensd!',
                'Wprowadzona wartość jest za wysoka. Zostanie ona zmniejszona do maks. dopuszczalnej wartości.',
                'Zadané číslo je příliš vysoké. Jste omezeni na max. přípustnou hodnotu!'
            ],
            'numberOfStartupsColdEnteredValueTooHigh': {
                'title': [
                    'Number of start-ups (cold)',
                    'Anzahl der Anläufe (kalt)',
                    'Número de arranques (en frío)',
                    'Nombre de démarrages (à froid)',
                    'Numero di avviamenti (a freddo)',
                    'Número de arranques (frio)',
                    '启动次数（冷）',
                    'Başlatma sayısı (soğuk)',
                    'Aantal starts (koud)',
                    'Liczba rozruchów (zimny)',
                    'Počet rozběhů (za studena)'
                ],
                'text': [
                    'The entered value is too high. The value will be reduced to the allowed maximum value.',
                    'Eingetragene Zahl ist zu groß. Sie wird auf den maximal zulässigen Wert begrenzt.',
                    'El número introducido es demasiado grande. Se limitará al valor máximo admisible.',
                    'Le nombre saisi est trop grand. Il est limité à la valeur maximale admissible.',
                    'Il numero inserito è troppo grande. Verrà limitato al valore massimo consentito.',
                    'Número registado é demasiado elevado. Este é limitado ao valor máximo permitido.',
                    '输入的值过大。该值将被允许范围内的最大值替换。',
                    'Girilen sayı aşırı büyük. İzin verilen azami değerle sınırlandı.',
                    'Ingegeven getal is te groot. Ze wordt tot de max. toegelaten waarde begrensd.',
                    'Wprowadzona wartość jest za wysoka. Zostanie ona zmniejszona do dopuszczalnej wartości maksymalnej.',
                    'Zadané číslo je příliš vysoké. Jste omezeni na maximální přípustnou hodnotu.'
                ]
            },
            'numberOfStartupsWarmEnteredValueTooHigh': {
                'title': [
                    'Number of start-ups (warm)',
                    'Anzahl der Anläufe (warm)',
                    'Número de arranques (en caliente)',
                    'Nombre de démarrages (à chaud)',
                    'Numero di avviamenti (a caldo)',
                    'Número de arranques (quente)',
                    '启动次数（热）',
                    'Başlatma sayısı (sıcak)',
                    'Aantal starts (warm)',
                    'Liczba rozruchów (ciepły)',
                    'Počet rozběhů (za tepla)'
                ],
                'text': [
                    'The entered value is too high. The value will be reduced to the allowed maximum value.',
                    'Eingetragene Zahl ist zu groß. Sie wird auf den maximal zulässigen Wert begrenzt.',
                    'El número introducido es demasiado grande. Se limitará al valor máximo admisible.',
                    'Le nombre saisi est trop grand. Il est limité à la valeur maximale admissible.',
                    'Il numero inserito è troppo grande. Verrà limitato al valore massimo consentito.',
                    'Número registado é demasiado elevado. Este é limitado ao valor máximo permitido.',
                    '输入的值过大。该值将被允许范围内的最大值替换。',
                    'Girilen sayı aşırı büyük. İzin verilen azami değerle sınırlandı.',
                    'Ingegeven getal is te groot. Ze wordt tot de max. toegelaten waarde begrensd.',
                    'Wprowadzona wartość jest za wysoka. Zostanie ona zmniejszona do dopuszczalnej wartości maksymalnej.',
                    'Zadané číslo je příliš vysoké. Jste omezeni na maximální přípustnou hodnotu.'
                ]
            }
        },
        'error': {
            'ipc': {
                'text': [
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error',
                    'IPC request error'
                ]
            },
            'documentGeneration': {
                'title': [
                    'Documentation',
                    'Dokumentation',
                    'Documentación',
                    'Documentation',
                    'Documentazione',
                    'Documentação',
                    '文档',
                    'Dokümantasyon',
                    'Documentatie',
                    'Dokumentacja',
                    'Dokumentace'
                ],
                'text': [
                    'Document generation not possible. Please try later again.',
                    'Erstellen der Dokumentation nicht möglich. Bitte später noch einmal versuchen.',
                    'No es posible crear la documentación. Inténtelo de nuevo más tarde.',
                    'Création de la documentation impossible. Veuillez réessayer ultérieurement.',
                    'Impossibile creare la documentazione Riprovare in seguito',
                    'Não é possível criar documentação. Tente novamente mais tarde.',
                    '无法生成文档请稍后重试。',
                    'Dokümantasyon oluşturma olanaklı değil. Lütfen daha sonra tekrar deneyiniz.',
                    'Aanmaken van de documentatie niet mogelijk. Probeer het later nogmaals.',
                    'Utworzenie dokumentacji nie jest możliwe. Spróbuj ponownie później.',
                    'Sestavení dokumentace není možné. Zkuste to prosím později ještě jednou.'
                ]
            },
            'chartImageGeneration': [
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.',
                'Chart image generation not possible. Please try later again.'
            ],
            'filter': {
                'title': [
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load',
                    'Filter load'
                ],
                'text': [
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.',
                    'Cannot load filter values. Please try later again.'
                ]
            },
            'allCurves': {
                'title': [
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load',
                    'Curves load'
                ],
                'text': [
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.',
                    'Cannot load curve values. Please try later again.'
                ]
            }
        }
    },
    'units': {
        'rpm': [
            '[rpm]',
            '[1/min]',
            '[1/min]',
            '[tr/min]',
            '[1/min]',
            '[1/min]',
            '[rpm]',
            '[1/dak]',
            '[1/min]',
            '[1/min]',
            '[ot/min]'
        ]
    },
    'dialog': {
        'info': {
            'loadInertiaTooHigh': {
                'title': [
                    'Load moment of inertia:',
                    'Lastträgheitsmoment:',
                    'Momento de inercia de la carga:',
                    'Couple d\'inertie de la charge : ',
                    'Momento di inerzia del carico:',
                    'Binário de inércia de carga:',
                    '负载转动惯量：',
                    'Yük eylemsizlik momenti:',
                    'Lasttraagheidsmoment:',
                    'Moment bezwładności obciążenia:',
                    'Moment setrvačnosti zátěže:'
                ],
                'text': [
                    'Load moment of inertia value is too high for selected numbers of start-ups.|Expert Suite reduced your load moment of inertia value automatically to max. allowed value.|If you can not reduce further the numbers of desired start-ups or load moment of inertia > please select a larger motor!',
                    'Lastträgheitsmoment ist für die gewählte Anzahl der Anläufe zu hoch!|Expert Suite reduzierte ihren Wert für das Lastträgheitsmoment automatisch auf den max. zulässigen Wert!|Wenn Sie die gewünschte Anzahl der Anläufe oder das Lastträgheitsmoment nicht weiter reduzieren können, dann wählen Sie bitte einen größeren Motor!',
                    '¡El momento de inercia de la carga es excesivo para el número seleccionado de arranques!|¡Expert Suite ha reducido el valor del momento de inercia de la carga automáticamente al valor máx. admisible!|¡Si no puede reducir más el momento de inercia de la carga ni el número de arranques deseado, seleccione un motor mayor!',
                    'Le couple d\'inertie de la charge est trop élevé pour le nombre de démarrages sélectionné!|Expert Suite a automatiquement réduit sa valeur pour le couple d\'inertie de la charge à la valeur maximale admissible !|S\'il est impossible de réduire davantage le nombre de démarrages souhaité ou le couple d\'inertie de la charge, veuillez choisir un moteur plus grand !',
                    'Il momento d\'inerzia del carico è troppo alto per il numero di avviamenti selezionato!|Expert Suite ha ridotto automaticamente il valore del momento d\'inerzia del carico al valore massimo consentito!|Se non è possibile ridurre ulteriormente il numero di avviamenti desiderato o il momento d\'inerzia del carico, selezionare un motore più grande!',
                    'O binário de inércia de carga é demasiado elevado para o número de arranques! O |Expert Suite reduziu o valor para o binário de inércia de carga automaticamente para o valor máx. permitido! |Se não puder reduzir mais o número de arranques permitido ou o binário de inércia de carga, selecione um motor maior!',
                    '负载转动惯量值对于所选择的启动次数而言过高！该值将被|Expert Suite 自动替换为允许范围内的负载转动惯量的最大值！|如您不想减少启动次数或降低负载转动惯量，则请选择更高规格的电机！',
                    'Seçilen başlatma sayısı için yük eylemsizlik momenti aşırı yüksek! |Expert Suite yük eylemsizlik momenti değerini otomatik olarak izin verilen azami değere indirdi! |İstenilen başlatma sayısını veya yük eylemsizlik momentini daha fazla düşürememeniz halinde, lütfen daha büyük bir motor seçiniz!',
                    'Laststraagheidsmoment is voor het gekozen aantal starts te hoog!|Expert Suite reduceerde hun waarde voor het lasttraagheidsmoment automatisch tot de toegelaten waarde!|Als u het gewenste aantal starts of het lasttraagheidsmoment niet verder kunt reduceren, kies dan een grotere motor!',
                    'Moment bezwładności obciążenia jest za wysoki dla wybranej liczby rozruchów!|Expert Suite automatycznie zmniejszył wartość dla momentu bezwładności obciążenia do maks. dopuszczalnej wartości!|Jeżeli nie jest możliwe dalsze zmniejszenie liczby rozruchów lub momentu bezwładności obciążenia, należy wybrać większy silnik!',
                    'Moment setrvačnosti zátěže je pro zvolený počet rozběhů příliš vysoký!|Aplikace Expert Suite automaticky snížila vaši hodnotu pro moment setrvačnosti zátěže na max. přípustnou hodnotu!|Jestliže požadovaný počet rozběhů nebo moment setrvačnosti zátěže není možné dále snížit, potom prosím vyberte větší motor!'
                ],
                'button': [
                    'Confirm',
                    'Bestätigen',
                    'Confirmar',
                    'Confirmation',
                    'Conferma',
                    'Confirmar',
                    '确认',
                    'Onayla',
                    'Bevestigen',
                    'Potwierdź',
                    'Potvrdit'
                ]
            },
            'gearboxInertiaValueTooLow': {
                'title': [
                    'Gearbox moment of inertia:',
                    'Trägheitsmoment des Getriebes:',
                    'Momento de inercia del reductor:',
                    'Moment d\'inertie du réducteur : ',
                    'Momento di inerzia del riduttore:',
                    'Binário de inércia da engrenagem:',
                    '齿轮箱转动惯量：',
                    'Dişlinin eylemsizlik momenti:',
                    'Traagheidsmoment van de transmissie:',
                    'Moment bezwładności przekładni:',
                    'Moment setrvačnosti převodovky:'
                ],
                'text': [
                    'Gearbox moment of inertia value is too low.|Expert Suite increased your gearbox moment of inertia value automatically to the min. value!',
                    'Trägheitsmoment des Getriebes ist zu klein.|Expert Suite erhöhte das Trägheitsmoment des Getriebes automatisch auf den min. Wert!',
                    'El momento de inercia del reductor es insuficiente.|¡Expert Suite ha aumentado automáticamente el momento de inercia del reductor al valor mín.!',
                    'Le moment d\'inertie du réducteur est trop bas. |Expert Suite a automatiquement augmenté le moment d\'inertie du réducteur à la valeur minimale !',
                    'Il momento d\'inerzia del riduttore è troppo piccolo.|Expert Suite ha aumentato automaticamente il momento d\'inerzia del riduttore al valore minimo!',
                    'O binário de inércia da engrenagem é demasiado pequeno. O |Expert Suite aumentou o binário de inércia da engrenagem automaticamente para o valor mínimo!',
                    '齿轮箱转动惯量过小。该值将被|Expert Suite 自动替换为允许范围内的齿轮箱转动惯量的最小值！',
                    'Dişlinin eylemsizlik momenti aşırı küçük. |Expert Suite, dişlinin eylemsizlik momentini otomatik olarak asgari değere yükseltti!',
                    'Traagheidsmoment van de transmissie is te klein.|Expert Suite verhoogde het traagheidsmoment van de transmissie automatisch tot de min. waarde!',
                    'Moment bezwładności przekładni jest za niski.|Expert Suite automatycznie zwiększył moment bezwładności przekładni do wartości minimalnej!',
                    'Moment setrvačnosti převodovky je příliš malý.|Aplikace EXPERT Suite automaticky zvýšila moment setrvačnosti převodovky na min. hodnotu!'
                ],
                'button': [
                    'CONFIRM',
                    'BESTÄTIGEN',
                    'Confirmar',
                    'Confirmation',
                    'Conferma',
                    'Confirmar',
                    '确认',
                    'Onayla',
                    'Bevestigen',
                    'Potwierdź',
                    'Potvrdit'
                ]
            },
            'loadInertiaValueTooLow': {
                'title': [
                    'Load moment of inertia:',
                    'Lastträgheitsmoment',
                    'Momento de inercia de la carga:',
                    'Couple d\'inertie de la charge : ',
                    'Momento di inerzia del carico:',
                    'Binário de inércia de carga:',
                    '负载转动惯量：',
                    'Yük eylemsizlik momenti:',
                    'Lasttraagheidsmoment:',
                    'Moment bezwładności obciążenia:',
                    'Moment setrvačnosti zátěže:'
                ],
                'text': [
                    'Load moment of inertia value is too low.|Expert Suite increased your load moment of inertia value automatically to the min. value!',
                    'Lastträgheitsmoment ist zu klein|Expert Suite erhöhte das Lastträgheitsmoment automatisch auf den min. Wert!',
                    'El momento de inercia de la carga es insuficiente.|¡Expert Suite ha aumentado automáticamente el momento de inercia de la carga al valor mín.!',
                    'Le couple d\'inertie de la charge est trop bas|Expert Suite a automatiquement augmenté le couple d\'inertie de la charge à la valeur minimale !',
                    'Il momento d\'inerzia del carico è troppo piccolo.|Expert Suite ha aumentato automaticamente il momento d\'inerzia del carico al valore minimo!',
                    'O binário de inércia de carga é demasiado pequeno O |Expert Suite aumentou o binário de inércia de carga automaticamente para o valor mínimo!',
                    '负载转动惯量过小。该值将被|Expert Suite 自动替换为允许范围内的负载转动惯量的最小值！',
                    'Eylemsizlik momenti aşırı küçük. |Expert Suite, eylemsizlik momentini otomatik olarak asgari değere yükseltti!',
                    'Lasttraagheidsmoment is te klein.|Expert Suite verhoogde het lasttraagheidsmoment automatisch tot de min. waarde!',
                    'Moment bezwładności obciążenia jest za niski.|Expert Suite automatycznie zwiększył moment bezwładności obciążenia do wartości minimalnej!',
                    'Moment setrvačnosti zátěže je příliš malý.|Aplikace EXPERT Suite automaticky zvýšila moment setrvačnosti zátěže na min. hodnotu!'
                ],
                'button': [
                    'CONFIRM',
                    'BESTÄTIGEN',
                    'Confirmar',
                    'Confirmation',
                    'Conferma',
                    'Confirmar',
                    '确认',
                    'Onayla',
                    'Bevestigen',
                    'Potwierdź',
                    'Potvrdit'
                ]
            },
            'numberOfStartupsValueTooHigh': {
                'title': [
                    'Number of startups:',
                    'Anzahl der Anläufe:',
                    'Número de arranques:',
                    'Nombre de démarrages :',
                    'Numero di avvii:',
                    'Número de arranques:',
                    '启动次数：',
                    'Başlatma sayısı:',
                    'Aantal opstartingen',
                    'Liczba rozruchów:',
                    'Počet spuštění:'
                ],
                'text': [
                    'Number of startups value is too high.|Expert Suite reduced your number of startups value automatically to max. allowed value.|If you can not reduce further the numbers of desired number of startups > please select a larger motor!',
                    'Eingetragene Zahl der Anläufe ist zu groß.|Expert Suite wird sie auf den maximal zulässigen Wert begrenzen.|Wenn Sie die gewünschte Anzahl der Anläufe nicht weiter reduzieren können, dann wählen Sie bitte einen größeren Motor!',
                    'El valor del número de arranques es demasiado alto.|Expert Suite ha reducido automáticamente el valor del número de arranques al valor máx. admisible.|¡Si no puede reducir más el número de arranques deseado, seleccione un motor mayor!',
                    'La valeur du nombre de démarrages est trop élevée.|Expert Suite a réduit automatiquement la valeur du nombre de démarrages à la valeur maximale autorisée.|Si vous ne pouvez pas réduire davantage le nombre de démarrages souhaités > veuillez sélectionner un moteur plus grand !',
                    'Il valore del numero di avviamenti è troppo alto.|Expert Suite ha ridotto automaticamente il valore del numero di avviamenti al massimo consentito.|Se non è possibile diminuire ulteriormente il numero di avviamenti desiderato > selezionare un motore più grande!',
                    'O número de arranques é muito alto.|O Expert Suite reduziu automaticamente o número de arranques para o valor máximo permitido.|Se não puder reduzir ainda mais o número desejado de arranques > selecione um motor maior!',
                    '启动次数过多。|Expert Suite 会自动将启动次数降低为允许的最大值。|如果不能进一步降低所需的启动次数 > 请选择一个更大规格的电机！',
                    'Başlatma sayısı değeri çok yüksek.|Uzman Süiti başlatma sayısı değerinizi otomatik olarak, izin verilen maks. değerine düşürdü.|İstediğiniz başlatma sayısı sayısını daha fazla düşüremiyorsanız > lütfen daha büyük bir motor seçin!',
                    'Getal voor opstartwaarde is te hoog.|Expert Suite heeft uw getal voor de opstartwaarde verlaagd tot de max. toegestane waarde.|Als u het aantal gewenste opstartingen niet verder kunt verlagen > kies dan een grotere motor!',
                    'Wartość liczby rozruchów jest zbyt wysoka.|Expert Suite zredukował automatycznie liczbę rozruchów do maksymalnej dopuszczalnej wartości.|Jeśli nie można już zredukować liczby rozruchów > proszę wybrać większy silnik!',
                    'Hodnota počtu spuštění je příliš vysoká.|Expert Suite automaticky snížila hodnotu počtu spuštění na maximální povolenou hodnotu.|Pokud dále nemůžete snížit počet požadovaných spuštění >, zvolte větší motor!'
                ]
            }
        }
    },
    'infoMessages': {
        'curveCalculation': {
            '1001': [
                '100% linevoltage: Start-up warm possible',
                '100% Netzspannung: Anlauf aus dem warmen Zustand möglich',
                '100% tensión de red: es posible el arranque en caliente',
                'Tension réseau 100 % : Démarrage possible à partir de l\'état chaud',
                '100% tensione di rete: avviamento a caldo possibile',
                '100% tensão de rede: Arranque pode ser realizado a partir do estado quente',
                '100% 电网电压：可执行热启动',
                '%100 şebeke gerilimi: Sıcak durumdan başlatma olanaklı',
                '100% netspanning: Starten vanuit de warme toestand mogelijk',
                '100 % napięcie sieci: Rozruch ze stanu ciepłego jest możliwy',
                '100% síťové napětí: Rozběh z teplého stavu je možný'
            ],
            '1002': [
                '100% linevoltage: Start-up cold possible',
                '100% Netzspannung: Anlauf aus dem kalten Zustand möglich',
                '100% tensión de red: es posible el arranque en frío',
                'Tension réseau 100 % : Démarrage possible à partir de l\'état froid',
                '100% tensione di rete: avviamento a freddo possibile',
                '100% tensão de rede: Arranque pode ser realizado a partir do estado frio',
                '100% 电网电压：可执行冷启动',
                '%100 şebeke gerilimi: Soğuk durumdan başlatma olanaklı',
                '100% netspanning: Starten vanuit de koude toestand mogelijk',
                '100 % napięcie sieci: Rozruch ze stanu zimnego jest możliwy',
                '100% síťové napětí: Rozběh z chladného stavu je možný'
            ],
            '1003': [
                'Undervoltage starting: Start-up warm possible',
                'Reduzierte Anlaufspannung: Anlauf aus dem warmen Zustand möglich',
                'Tensión de arranque reducida: es posible el arranque en caliente',
                'Tension de démarrage réduite : Démarrage possible à partir de l\'état chaud',
                'Tensione di avviamento ridotta: avviamento a caldo possibile',
                'Tensão de arranque reduzida: Arranque pode ser realizado a partir do estado quente',
                '启动电压降低：可执行热启动',
                'Düşürülmüş başlatma gerilimi: Sıcak durumdan başlatma olanaklı',
                'Gereduceerde startspanning: Starten vanuit de warme toestand mogelijk',
                'Obniżone napięcie rozruchowe: Rozruch ze stanu ciepłego jest możliwy',
                'Snížené rozběhové napětí: Rozběh z teplého stavu je možný'
            ],
            '1004': [
                'Undervoltage starting: Start-up cold possible',
                'Reduzierte Anlaufspannung: Anlauf aus dem kalten Zustand möglich',
                'Tensión de arranque reducida: es posible el arranque en frío',
                'Tension de démarrage réduite : Démarrage possible à partir de l\'état froid',
                'Tensione di avviamento ridotta: avviamento a freddo possibile',
                'Tensão de arranque reduzida: Arranque pode ser realizado a partir do estado frio',
                '启动电压降低：可执行冷启动',
                'Düşürülmüş başlatma gerilimi: Soğuk durumdan başlatma olanaklı',
                'Gereduceerde startspanning: Starten vanuit de koude toestand mogelijk',
                'Obniżone napięcie rozruchowe: Rozruch ze stanu zimnego jest możliwy',
                'Snížené rozběhové napětí: Rozběh z chladného stavu je možný'
            ],
            '1005': [
                'Start-up possible - Motor however is overloaded for continuous running in Duty Type S1',
                'Anlauf ist möglich - Motor ist jedoch überlastet bei anschließendem Betrieb in Betriebsart S1',
                'Arranque posible: sin embargo, el motor está sobrecargado si a continuación se opera en el modo de operación S1',
                'Démarrage possible - le moteur est cependant surchargé en cas de fonctionnement ultérieur en mode S1',
                'L\'avviamento è possibile, ma il motore viene sovraccaricato nel successivo funzionamento in modo operativo S1',
                'É possível realizar arranque - No entanto, o motor está sobrecarregado na operação subsequente no modo de operação S1',
                '可启动 - 在 S1 连续工作制下运行时电机仍会过载',
                'Başlatma olanaklı - Ancak daha sonra S1 işletim türünde işletim halinde, motor aşırı yüklenir',
                'Starten is mogelijk - Motor is echter overbelast bij aansluitend bedrijf in bedrijfsmodus S1',
                'Rozruch jest możliwy - jednak podczas dalszej pracy w trybie pracy S1 silnik jest przeciążony.',
                'Rozběh je možný - motor je však při následném provozu v provozním režimu S1 přetížený'
            ]
        }
    },
    'errorMessages': {
        'load': {
            '0': [
                '${x} is identical to ${y}! You have to insert different numerical data',
                '${x} ist identisch mit ${y}! Sie müssen unterschiedliche Drehzahlen eingeben',
                '¡${x} es idéntica a ${y}! Debe introducir velocidades diferentes',
                '${x} est identique à ${y} ! Différentes vitesses doivent être saisies',
                '${x} è identico a ${y}! Immettere numeri di giri diversi',
                '${x} é idêntico com ${y}! É necessário introduzir rotações diferentes',
                '${x} 与 ${y} 相同！您必须输入不同的转速',
                '${x} ile ${y} özdeş! Birbirinden farklı devir sayıları girmeniz gerekir',
                '${x} is identiek met ${y}! U moet verschillende toerentallen ingeven',
                '${x} jest identyczny z ${y}! Należy wprowadzić różne prędkości obrotowe',
                '${x} je identická s hodnotou ${y}! Musíte zadat odlišné otáčky'
            ],
            '1': [
                'The speed ${x} must be greater than 0',
                'Die Drehzahl ${x} muss größer 0 sein',
                'La velocidad ${x} debe ser mayor que 0',
                'La vitesse ${x} doit être supérieure à 0',
                'Il numero di giri ${x} deve essere maggiore di 0',
                'As rotações ${x} têm que ser superiores a 0',
                '转速 ${x} 必须大于 0',
                'Devir sayısı ${x} > 0 olması gerekir',
                'Het toerental ${x} moet groter zijn dan 0',
                'Prędkość obrotowa ${x} musi być większa niż 0',
                'Otáčky ${x} musí být větší než 0'
            ],
            '2': [
                'The speed ${x} must be greater than 0 or equal 0',
                'Die Drehzahl ${x} muss größer 0 oder gleich 0 sein',
                'La velocidad ${x} debe ser mayor o igual que 0',
                'La vitesse ${x} doit être supérieure ou égale à 0',
                'Il numero di giri ${x} deve essere maggiore di 0 o uguale a 0',
                'As rotações ${x} têm que ser superiores a 0 ou igual a 0',
                '转速 ${x} 必须大于或等于 0',
                'Devir sayısı ${x} >= 0 olması gerekir',
                'Het toerental ${x} moet groter zijn dan 0 of gelijk zijn aan 0',
                'Prędkość obrotowa ${x} musi być większa niż 0 lub równa 0',
                'Otáčky ${x} musí být větší než 0 nebo se rovnat 0'
            ],
            '3': [
                'The speed ${x} must be greater than ${y}',
                'Die Drehzahl ${x} muss größer ${y} sein',
                'La velocidad ${x} debe ser mayor que ${y}',
                'La vitesse ${x} doit être supérieure à ${y}',
                'Il numero di giri ${x} deve essere maggiore di ${y}',
                'As rotações ${x} têm que ser superiores a ${y}',
                '转速 ${x} 必须大于 ${y}',
                'Devir sayısı ${x} > ${y} olması gerekir',
                'Het toerental ${x} moet groter zijn dan ${y}',
                'Prędkość obrotowa ${x} musi być większa niż ${y}',
                'Otáčky ${x} musí být větší než ${y}'
            ],
            '4': [
                'The speed is too high! You are allowed to set 10 times motor synchronous speed',
                'Die Drehzahl ist zu groß! Sie dürfen max. 10 fache Motor-Synchron-Drehzahl eingeben',
                '¡La velocidad es excesiva! Se permite introducir como máximo una velocidad 10 veces mayor que la velocidad síncrona del motor',
                'La vitesse est trop élevée ! Il est possible de saisir jusqu\'à 10 fois la vitesse synchrone du moteur',
                'Il numero di giri è troppo elevato! Si può immettere al massimo un valore 10 volte superiore al numero di giri del motore sincrono',
                'As rotações são demasiado elevadas! Podem ser introduzidas, no máximo, as rotações síncronas o motor 10 vezes maiores',
                '转速过大！您最大可输入电机同步转速 10 倍的值',
                'Devir sayısı aşırı yüksek! Devir sayısı olarak motor senkron devir sayısının azami 10 katını girebilirsiniz',
                'Het toerental is te groot! Er mag max. een 10-voudig synchroon toerental voor de motor worden ingegeven',
                'Prędkość obrotowa jest za wysoka! Można wprowadzić maksymalnie 10-krotną wartość prędkości synchronicznej silnika',
                'Otáčky jsou příliš vysoké! Smíte zadat max. 10-násobek synchronních otáček motoru'
            ],
            '5': [
                'The torque ${x} must be greater than 0',
                'Das Drehmoment ${x} muss größer 0 sein',
                'El par ${x} debe ser mayor que 0',
                'Le couple ${x} doit être supérieur à 0',
                'La coppia ${x} deve essere maggiore di 0',
                'O binário ${x} tem de ser superior a 0',
                '转矩 ${x} 必须大于 0',
                'Tork ${x} > 0 olması gerekir',
                'Het draaimoment ${x} moet groter zijn dan 0',
                'Moment obrotowy ${x} musi być większy niż 0',
                'Moment ${x} musí být větší než 0'
            ],
            '6': [
                'The torque ${x} must be greater than 0 or equal 0',
                'Das Drehmoment ${x} muss größer 0 oder gleich 0 sein',
                'El par ${x} debe ser mayor o igual que 0',
                'Le couple ${x} doit être supérieur ou égal à 0',
                'La coppia ${x} deve essere maggiore di 0 o uguale a 0',
                'O binário ${x} tem de ser superior a 0 ou igual a 0',
                '转矩 ${x} 必须大于或等于 0',
                'Tork ${x} >= 0 olması gerekir',
                'Het draaimoment ${x} moet groter zijn dan 0 of gelijk zijn aan 0',
                'Moment ${x} musi być większy od 0 lub równy 0',
                'Moment ${x} musí být větší než 0 nebo se rovnat 0'
            ],
            '7': [
                'The torque ${x} must be greater than ${y}',
                'Das Drehmoment ${x} muss größer ${y} sein',
                'El par ${x} debe ser mayor que ${y}',
                'Le couple ${x} doit être supérieur à ${y}',
                'La coppia ${x} deve essere maggiore di ${y}',
                'O binário ${x} tem de ser superior a ${y}',
                '转矩 ${x} 必须大于 ${y}',
                'Tork ${x} > ${y} olması gerekir',
                'Het draaimoment ${x} moet groter zijn dan ${y}',
                'Moment obrotowy ${x} musi być większy niż ${y}',
                'Moment ${x} musí být větší než ${y}'
            ],
            '8': [
                'The torque is too high! You are allowed to set 10 times motor rated torque',
                'Das Drehmoment ist zu groß! Sie dürfen max. 10 faches Motor-Nennmoment eingeben',
                '¡El par es demasiado grande! Se permite introducir como máximo un par 10 veces mayor que el par nominal del motor',
                'Le couple est trop élevé ! Il est possible de saisir jusqu\'à 10 fois le couple nominal du moteur',
                'La coppia è troppo elevata! Si può immettere al massimo un valore 10 volte superiore alla coppia nominale del motore',
                'O binário é demasiado elevado Pode ser introduzido, no máximo, o binário nominal do motor 10 vezes maior',
                '转矩过大！您最大可输入电机额定转矩 10 倍的值',
                'Tork aşırı yüksek! Tork olarak motor nominal torkunun azami 10 katını girebilirsiniz',
                'Het draaimoment is te groot! Er mag max. een 10-voudig nominaal moment voor de motor worden ingegeven',
                'Moment obrotowy jest za wysoki! Można wprowadzić maksymalnie 10-krotność znamionowego momentu obrotowego silnika',
                'Moment je příliš vysoký! Smíte zadat max. 10-násobek jmenovitého momentu motoru'
            ]
        },
        'curveCalculation': {
            '-1': [
                'No DOL operation!',
                'Direktanlauf (DOL) nicht möglich!',
                '¡No es posible el arranque directo (DOL)!',
                'Démarrage direct (DOL) impossible !',
                'Avviamento diretto (DOL) non possibile!',
                'Não é possível arranque direto (DOL)!',
                '无法直接启动 (DOL)！',
                'Direkt başlatma (DOL) olanaklı değil!',
                'Directe start (DOL) niet mogelijk!',
                'Rozruch bezpośredni (DOL) nie jest możliwy!',
                'Přímý rozběh (DOL) není možný!'
            ],
            '-2': [
                'No Star/Delta operation!',
                'Stern-Dreick-Anlauf (Y/D) nicht möglich!',
                '¡No es posible el arranque en estrella/triángulo (Y/D)!',
                'Démarrage étoile-triangle (Y/D) impossible !',
                'Avviamento stella-triangolo (Y/D) non possibile!',
                'Não é possível arranque estrela-triângulo (Y/D)!',
                '无法星形/三角形启动 (Y/D)！',
                'Yıldız delta başlatma (Y/D) olanaklı değil!',
                'Ster-driehoek-Start (Y/D) niet mogelijk!',
                'Rozruch gwiazda-trójką (Y/D) nie jest możliwy!',
                'Rozběh s přepínáním hvězda-trojúhelník (Y/D) není možný!'
            ],
            '0': [
                'Missing parameter',
                'Parameter fehlen',
                'Faltan parámetros',
                'Paramètres manquants',
                'Parametri mancanti',
                'Faltam parâmetros',
                '缺少参数',
                'Parametreler eksik',
                'Parameters ontbreken',
                'Brak parametrów',
                'Chybějí parametry'
            ],
            '1': [
                'Load operation point out of allowed range! Motor size too small or countertorque too high or motor pole number is not suitable.',
                'Lastbetriebspunkt ist außerhalb des zulässigen Bereichs! Motor ist zu klein oder das Gegenmoment zu hoch oder Motorpolzahl ist nicht geeignet.',
                '¡El punto de trabajo con carga se encuentra fuera del rango admisible! El motor es demasiado pequeño o el par antagonista demasiado alto o el número de polos del motor no es adecuado.',
                'Point de fonctionnement de la charge hors de la plage admissible ! Le moteur est trop petit ou le couple résistant trop élevé ou le nombre de pôles du moteur n\'est pas adapté.',
                'Il punto operativo del carico è al di fuori del campo ammesso! Il motore è troppo piccolo o la coppia antagonista è troppo elevata o il numero di poli del motore non è adeguato.',
                'Ponto de operação carga fora da gama permitida! O motor é demasiado pequeno ou o contra-binário demasiado elevado ou o número de pólos do motor não é indicado.',
                '负载运行点不在允许范围内！电机过小，反向转矩过大或电机极数不合适。',
                'Yük işletim noktası izin verilen aralığın dışında! Motor çok küçük veya karşı tork çok yüksek veya motor kutup sayısı uygun değil.',
                'Lastbedrijfspunt is buiten het toegestane bereik! Motor is te klein of het contramoment te hoog, of motorpoolgetal is niet geschikt.',
                'Punkt pracy obciążenia jest poza dopuszczalnym zakresem! Silnik jest za mały lub moment oporowy jest za duży albo liczba biegunów silnika nie jest odpowiednia.',
                'Pracovní bod při zatížení je mimo povolený rozsah! Motor je příliš malý nebo moment zátěže je příliš vysoký nebo počet pólů není vhodný.'
            ],
            '2': [
                'Start-up not possible for rated voltage! Motor size is too small or countertorque too high or motor characteristic is not suitable.',
                'Anlauf bei Bemessungsspannung nicht möglich! Motor ist zu klein oder das Gegenmoment zu hoch oder Motormomentkennlinie ist nicht geeignet.',
                '¡No es posible el arranque con la tensión asignada! El motor es demasiado pequeño o el par antagonista demasiado alto o la curva característica de par del motor no es adecuada.',
                'Démarrage impossible à la tension assignée ! Le moteur est trop petit ou le couple résistant trop élevé ou la caractéristique du couple moteur n\'est pas adaptée.',
                'L\'avviamento alla tensione nominale non è possibile! Il motore è troppo piccolo o la coppia antagonista è troppo elevata o la caratteristica di coppia del motore non è adeguata.',
                'Não é possível realizar arranque com tensão de referência! O motor é demasiado pequeno ou o contra-binário demasiado elevado ou a curva caraterística do binário do motor não é indicada.',
                '额定电压下无法启动！电机过小，反向转矩过大或电机转矩特性曲线不合适。',
                'Anma geriliminde başlatma olanaklı değil! Motor çok küçük veya karşı tork çok yüksek veya motor tork karakteristiği uygun değil.',
                'Start bij nominale spanning niet mogelijk! Motor is te klein of het contramoment te hoog, of de karakteristiek van het motormoment is niet geschikt.',
                'Rozruch przy napięciu znamionowym nie jest możliwy! Silnik jest za mały lub moment oporowy jest za duży albo charakterystyka momentu silnika nie jest odpowiednia.',
                'Rozběh při jmenovitém napětí není možný! Motor je příliš malý nebo moment zátěže je příliš vysoký nebo momentová charakteristika motoru není vhodná.'
            ],
            '3': [
                'Motor overload for rated mains voltage! Motor size is too small or countertorque too high.',
                'Motor ist bei Bemessungsspannung des Netzes überlastet! Der Motor ist zu klein oder das Gegenmoment zu hoch.',
                '¡El motor está sobrecargado a la tensión asignada de la red! El motor es demasiado pequeño o el par antagonista demasiado alto.',
                'Le moteur est surchargé à la tension assignée du réseau ! Le moteur est trop petit ou le couple résistant trop élevé.',
                'Il motore è in sovraccarico alla tensione nominale di rete! Il motore è troppo piccolo o la coppia antagonista è troppo elevata.',
                'O motor está sobrecarregado com a tensão de referência! O motor é demasiado pequeno ou o contra-binário demasiado elevado.',
                '电网额定电压下电机过载！电机过小或反向转矩过大。',
                'Şebeke anma geriliminde motor aşırı yüklenmiş! Motor çok küçük veya karşı tork çok yüksek.',
                'Motor is bij nominale spanning van het net overbelast! De motor is te klein of het contramoment te hoog.',
                'Silnik jest przeciążony przy znamionowym napięciu sieci! Silnik jest za mały lub moment oporowy jest za duży.',
                'Motor je při jmenovitém napětí sítě přetížený! Motor je příliš malý nebo moment zátěže je příliš vysoký.'
            ],
            '4': [
                'Start-up not possible for reduced starting voltage! Motor size is too small or countertorque too high or  motor characteristic is not suitable',
                'Anlauf bei der reduzierter Anlaufspannung ist nicht möglich! Motor ist zu klein oder Motormomentkennlinie ist nicht geeignet.',
                '¡No es posible el arranque con la tensión de arranque reducida! El motor es demasiado pequeño o la curva característica de par del motor no es adecuada.',
                'Démarrage à la tension de démarrage réduite impossible ! Le moteur est trop petit ou la caractéristique du couple moteur n\'est pas adaptée.',
                'L\'avviamento a tensione ridotta non è possibile! Il motore è troppo piccolo o la coppia antagonista non è adeguata.',
                'Não é possível realizar arranque com tensão de arranque reduzida! O motor é demasiado pequeno ou a curva caraterística do binário do motor não é indicada.',
                '启动电压降低时无法启动！电机过小或电机转矩特性曲线不合适。',
                'Azaltılmış başlatma gerilimi ile yol alma olanaklı değil! Motor çok küçük veya motor tork karakteristiği uygun değil.',
                'Start bij de gereduceerde startspanning is niet mogelijk! Motor is te klein of karakteristiek van motormoment is niet geschikt.',
                'Rozruch przy obniżonym napięciu rozruchowym nie jest możliwy! Silnik jest za mały lub charakterystyka momentu silnika nie jest odpowiednia.',
                'Rozběh při sníženém rozběhovém napětí není možný! Motor je příliš malý nebo momentová charakteristika motoru není vhodná.'
            ],
            '5': [
                'Motor overload for rated mains voltage! Motor size is too small or countertorque too high.',
                'Motor ist bei Bemessungsspannung des Netzes überlastet! Der Motor ist zu klein oder das Gegenmoment zu hoch.',
                '¡El motor está sobrecargado a la tensión asignada de la red! El motor es demasiado pequeño o el par antagonista demasiado alto.',
                'Le moteur est surchargé à la tension assignée du réseau ! Le moteur est trop petit ou le couple résistant trop élevé.',
                'Il motore è in sovraccarico alla tensione nominale di rete! Il motore è troppo piccolo o la coppia antagonista è troppo elevata.',
                'O motor está sobrecarregado com a tensão de referência! O motor é demasiado pequeno ou o contra-binário demasiado elevado.',
                '电网额定电压下电机过载！电机过小或反向转矩过大。',
                'Şebeke anma geriliminde motor aşırı yüklenmiş! Motor çok küçük veya karşı tork çok yüksek.',
                'Motor is bij nominale spanning van het net overbelast! De motor is te klein of het contramoment te hoog.',
                'Silnik jest przeciążony przy znamionowym napięciu sieci! Silnik jest za mały lub moment oporowy jest za duży.',
                'Motor je při jmenovitém napětí sítě přetížený! Motor je příliš malý nebo moment zátěže je příliš vysoký.'
            ],
            '6': [
                'Too little safety distance from load point to max. torque point! Motor size is too small or countertorque too high or choosen motor torque characteristic is not suitable.',
                'Zu kleiner Sicherheitsabstand zwischen Last und max. Moment an einem Punkt! Motor ist zu klein oder das Gegenmoment zu hoch oder Motormomentkennlinie ist nicht geeignet.',
                '¡Distancia de seguridad insuficiente entre la carga y el par máximo en un punto! El motor es demasiado pequeño o el par antagonista demasiado alto o la curva característica de par del motor no es adecuada.',
                'Distance de sécurité trop faible entre la charge et le couple max. en un point ! Le moteur est trop petit ou le couple résistant trop élevé ou la caractéristique du couple moteur n\'est pas adaptée.',
                'Distanza di sicurezza tra carico e coppia massima insufficiente in un punto! Il motore è troppo piccolo o la coppia antagonista è troppo elevata o la caratteristica di coppia del motore non è adeguata.',
                'Distância de segurança demasiado curta entre a carga e o binário máx. num ponto! O motor é demasiado pequeno ou o contra-binário demasiado elevado ou a curva caraterística do binário do motor não é indicada.',
                '某个运行点上负载与最大转矩之间的安全距离过小！电机过小，反向转矩过大或电机转矩特性曲线不合适。',
                'Bir noktada yük ile azami moment arasında yetersiz emniyet mesafesi! Motor çok küçük veya karşı tork çok yüksek veya motor tork karakteristiği uygun değil.',
                'Te kleine veiligheidsafstand tussen last en max. moment aan een punt! Motor is te klein of het contramoment te hoog, of de karakteristiek van het motormoment is niet geschikt.',
                'Za mały odstęp bezpieczeństwa od punktu obciążenia do maks. punktu momentu! Silnik jest za mały lub moment oporowy jest za duży albo charakterystyka momentu silnika nie jest odpowiednia.',
                'Příliš malá vzdálenost mezi pracovním bodem a max. momentem v jednom bodě! Motor je příliš malý nebo moment zátěže je příliš vysoký nebo momentová charakteristika motoru není vhodná.'
            ],
            '7': [
                'Start-up not possible - Accelerationtime exceeded - Motor is overloaded',
                'Anlauf nicht möglich - Beschleunigungszeit überschritten - Motor ist überlastet',
                'Arranque no posible: tiempo de aceleración rebasado, el motor está sobrecargado',
                'Démarrage impossible - temps d\'accélération dépassé - le moteur est surchargé',
                'Avviamento non possibile - Tempo di accelerazione superato - Motore in sovraccarico',
                'Não é possível realizar arranque - tempo de aceleração ultrapassado - motor está sobrecarregado',
                '无法启动 - 超出加速时间 - 电机过载',
                'Başlatma olanaklı değil - İvme süresinin üzerine çıkıldı - Motor aşırı yüklendi',
                'Starten niet mogelijk - Versnellingstijd overschreden - Motor is overbelast',
                'Rozruch niemożliwy - przekroczony czas przyspieszania - silnik jest przeciążony',
                'Rozběh není možný - doba zrychlení překročena - motor je přetížený'
            ],
            '8': [
                'Start-up possible - Motor however is overloaded for continuous running in Duty Type S1',
                'Anlauf ist möglich - Motor ist jedoch überlastet bei anschließendem Betrieb in Betriebsart S1',
                'Arranque posible: sin embargo, el motor está sobrecargado si a continuación se opera en el modo de operación S1',
                'Démarrage possible - le moteur est cependant surchargé en cas de fonctionnement ultérieur en mode S1',
                'L\'avviamento è possibile, ma il motore viene sovraccaricato nel successivo funzionamento in modo operativo S1',
                'É possível realizar arranque - No entanto, o motor está sobrecarregado na operação subsequente no modo de operação S1',
                '可启动 - 在 S1 连续工作制下运行时电机仍会过载',
                'Başlatma olanaklı - Ancak daha sonra S1 işletim türünde işletim halinde, motor aşırı yüklenir',
                'Starten is mogelijk - Motor is echter overbelast bij aansluitend bedrijf in bedrijfsmodus S1',
                'Rozruch jest możliwy - jednak podczas dalszej pracy w trybie pracy S1 silnik jest przeciążony.',
                'Rozběh je možný - motor je však při následném provozu v provozním režimu S1 přetížený'
            ],
            '9': [
                '100% linevoltage: Start-up warm not possible',
                '100% Netzspannung: Anlauf aus dem warmen Zustand nicht möglich',
                '100% tensión de red: no es posible el arranque en caliente',
                'Tension réseau 100 % : Démarrage impossible à partir de l\'état chaud',
                '100% tensione di rete: avviamento a caldo non possibile',
                '100% tensão de rede: Não é possível realizar arranque a partir do estado quente',
                '100% 电网电压：无法执行热启动',
                '%100 şebeke gerilimi: Sıcak durumda başlatma olanaklı değil',
                '100% netspanning: Starten vanuit de warme toestand niet mogelijk',
                '100 % napięcie sieci: Rozruch ze stanu ciepłego nie jest możliwy',
                '100% síťové napětí: Rozběh z teplého stavu není možný'
            ],
            '10': [
                '100% linevoltage: Start-up cold not possible',
                '100% Netzspannung: Anlauf aus dem kalten Zustand nicht möglich',
                '100% tensión de red: no es posible el arranque en frío',
                'Tension réseau 100 % : Démarrage impossible à partir de l\'état froid',
                '100% tensione di rete: avviamento a freddo non possibile',
                '100% tensão de rede: Não é possível realizar arranque a partir do estado frio',
                '100% 电网电压：无法执行冷启动',
                '%100 şebeke gerilimi: Soğuk durumdan başlatma olanaklı değil',
                '100% netspanning: Starten vanuit de koude toestand niet mogelijk',
                '100 % napięcie sieci: Rozruch ze stanu zimnego nie jest możliwy',
                '100% síťové napětí: Rozběh z chladného stavu není možný'
            ],
            '11': [
                'Undervoltage starting: Start-up warm not possible',
                'Reduzierte Anlaufspannung: Anlauf aus dem warmen Zustand nicht möglich',
                'Tensión de arranque reducida: no es posible el arranque en caliente',
                'Tension de démarrage réduite : Démarrage impossible à partir de l\'état chaud',
                'Tensione di avviamento ridotta: avviamento a caldo non possibile',
                'Tensão de arranque reduzida: Não é possível realizar arranque a partir do estado quente',
                '启动电压降低：无法执行热启动',
                'Düşürülmüş başlatma gerilimi: Sıcak durumda başlatma olanaklı değil',
                'Gereduceerde startspanning: Starten vanuit de warme toestand niet mogelijk',
                'Obniżone napięcie rozruchowe: Rozruch ze stanu ciepłego nie jest możliwy',
                'Snížené rozběhové napětí: Rozběh z teplého stavu není možný'
            ],
            '12': [
                'Undervoltage starting: Start-up cold not possible',
                'Reduzierte Anlaufspannung: Anlauf aus dem kalten Zustand nicht möglich',
                'Tensión de arranque reducida: no es posible el arranque en frío',
                'Tension de démarrage réduite : Démarrage impossible à partir de l\'état froid',
                'Tensione di avviamento ridotta: avviamento a freddo non possibile',
                'Tensão de arranque reduzida: Não é possível realizar arranque a partir do estado frio',
                '启动电压降低：无法执行冷启动',
                'Düşürülmüş başlatma gerilimi: Soğuk durumdan başlatma olanaklı değil',
                'Gereduceerde startspanning: Starten vanuit de koude toestand niet mogelijk',
                'Obniżone napięcie rozruchowe: Rozruch ze stanu zimnego nie jest możliwy',
                'Snížené rozběhové napětí: Rozběh z chladného stavu není možný'
            ],
            '1000': [
                'Start-up possible - Accelerationtime not exceeded - Motor is not overloaded',
                'Anlauf möglich - Beschleunigungszeit nicht überschritten - Motor ist nicht überlastet',
                'Arranque posible: tiempo de aceleración no rebasado, el motor no está sobrecargado',
                'Démarrage possible - temps d\'accélération non dépassé - le moteur n\'est pas surchargé',
                'Avviamento possibile - tempo di accelerazione non superato - motore non in sovraccarico',
                'É possível realizar arranque - Tempo de aceleração não ultrapassado - motor não está sobrecarregado',
                '无法启动 - 未超出加速时间 - 电机未过载',
                'Başlatma olanaklı - İvme süresinin üzerine çıkılmadı - Motor aşırı yüklenmedi',
                'Starten mogelijk - Versnellingstijd niet overschreden - Motor is niet overbelast',
                'Rozruch jest możliwy - czasu przyspieszania nie został przekroczony - silnik nie jest przeciążony',
                'Rozběh je možný - doba zrychlení není překročena - motor není přetížený'
            ]
        }
    },
    'chipsLane': {
        'reset': [
            'Reset values',
            'Auswahl zurücksetzen',
            'Anular selección',
            'Réinitialiser la sélection',
            'Annullare la selezione',
            'Repor seleção',
            '重置选择',
            'Seçimi sıfırla',
            'Selectie resetten',
            'Zresetuj wybór',
            'Obnovit původní výběr'
        ],
        'createDocument': [
            'Create document',
            'Dokument erstellen',
            'Crear documento',
            'Créer un document',
            'Creare documento',
            'Criar documento',
            '生成文档',
            'Doküman oluştur',
            'Document aanmaken',
            'Utwórz dokument',
            'Vytvoření dokumentu'
        ],
        'unitSystem': {
            'SI': [
                'International System of Units (SI)',
                'Internationales Einheitensystem (SI)',
                'Sistema internacional de unidades (SI)',
                'Système international d\'unités(SI)',
                'Sistema di unità internazionale (SI)',
                'Sistema internacional de unidades (SI)',
                '国际单位制 (SI)',
                'Uluslararası birim sistemi (SI)',
                'Internationaal eenhedensysteem (SI)',
                'Międzynarodowy układ jednostek (SI)',
                'Mezinárodní systém jednotek (SI)'
            ],
            'MKSA': [
                'MKSA System of Units',
                'MKSA Einheitensystem',
                'Sistema de unidades MKSA',
                'Système d\'unités MKSA',
                'Sistema di unità MKSA',
                'Sistema de unidades MKSA',
                'MKSA 单位制',
                'MKSA birim sistemi',
                'MKSA-eenheidssysteem',
                'Układ jednostek MKSA',
                'Systém jednotek MKSA'
            ],
            'Imperial': [
                'Imperial System of Units (US)',
                'Imperiales Einheitensystem (US)',
                'Sistema imperial de unidades (US)',
                'Système impérial d\'unités(US)',
                'Sistema di unità di misura imperiale (USA)',
                'Sistema imperial de unidades (EUA)',
                '英制单位制 (US)',
                'Amerikan birim sistemi (US)',
                'Imperiaal eenhedensysteem (US)',
                'Imperialny układ jednostek (US)',
                'Imperiální systém jednotek (US)'
            ]
        },
        'vsdCases': {
            'ConverterOperationVSD': [
                'Converter Operation',
                'Umrichterbetrieb',
                'Alimentación por convertidor',
                'Fonctionnement avec variateur',
                'Funzionamento con convertitore',
                'Modo do conversor',
                '变频运行',
                'Dönüştürücü işletimi',
                'Omvormerbedrijf',
                'Praca z przekształtnikiem',
                'Provoz s měničem'
            ],
            'LineOperation': [
                'Line Operation',
                'Netzbetrieb',
                'Alimentación por red',
                'Fonctionnement sur réseau',
                'Funzionamento da rete',
                'Modo de rede',
                '工频驱动',
                'Şebekede işletim',
                'Netbedrijf',
                'Praca sieciowa',
                'Provoz s připojením na síť'
            ],
            'LineAndConverterOperationVSD': [
                'Line & Converter Operation',
                'Netz und Umrichterbetrieb',
                'Alimentación por red y por convertidor',
                'Fonctionnement sur réseau et avec variateur',
                'Funzionamento da rete e funzionamento con convertitore',
                'Rede e operação do conversor',
                '工频和变频运行',
                'Şebeke ve dönüştürücü işletimi',
                'Net en omvormerbedrijf',
                'Praca sieciowa oraz praca z przekształtnikiem',
                'Provoz s připojením na síť a s měničem'
            ]
        }

    },
    'filters': {
        'motorSelection': {
            'placeholders': {
                'selectPower': [
                    'Select a power',
                    'Leistung auswählen',
                    'Seleccionar la potencia',
                    'Sélectionner la puissance',
                    'Selezionare la potenza',
                    'Selecionar potência',
                    '选择功率',
                    'Gücü seçin',
                    'Vermogen selecteren',
                    'Wybierz moc',
                    'Zvolte výkon'
                ],
                'selectMaterial': [
                    'Select a material',
                    'Material auswählen',
                    'Seleccionar el material',
                    'Sélectionner le matériau',
                    'Selezionare il materiale',
                    'Selecionar material',
                    '选择材料',
                    'Malzemeyi seçin',
                    'Materiaal selecteren',
                    'Wybierz materiał',
                    'Vyberte materiál'
                ],
                'selectType': [
                    'Select a type',
                    'Typ auswählen',
                    'Seleccionar el tipo',
                    'Sélectionner le type',
                    'Selezionare il tipo',
                    'Selecionar tipo',
                    '选择类型',
                    'Tipi seçin',
                    'Type kiezen',
                    'Wybierz typ',
                    'Zvolte typ'
                ],
                'selectSize': [
                    'Select a size',
                    'Baugröße auswählen',
                    'Seleccionar el tamaño',
                    'Sélectionner la taille',
                    'Selezionare la grandezza costruttiva',
                    'Selecionar tamanho',
                    '选择外形尺寸',
                    'Yapı büyüklüğünü seçin',
                    'Bouwgrootte selecteren',
                    'Wybierz wielkość mechaniczną',
                    'Zvolte konstrukční velikost'
                ],
                'selectMlfb': [
                    'Select MLFB',
                    'MLFB auswählen',
                    'Seleccionar la referencia MLFB',
                    'Sélectionner le numéro de référence',
                    'Selezionare MLFB',
                    'Selecionar MLFB',
                    '选择 MLFB',
                    'MLFB seçin',
                    'MLFB selecteren',
                    'Wybierz MLFB',
                    'Zvolte MLFB'
                ],
                'selectClass': [
                    'Select a class',
                    'Klasse auswählen',
                    'Seleccionar la clase',
                    'Sélectionner la classe',
                    'Selezionare la classe',
                    'Selecionar classe',
                    '选择等级',
                    'Sınıfı seçin',
                    'Klasse selecteren',
                    'Wybierz klasę',
                    'Zvolte třídu'
                ],
                'selectSpeed': [
                    'Select a speed',
                    'Drehzahl auswählen',
                    'Seleccionar la velocidad',
                    'Sélectionner la vitesse',
                    'Selezionare il numero di giri',
                    'Selecionar rotações',
                    '选择转速',
                    'Devir sayısını seçin',
                    'Toerental selecteren',
                    'Wybierz prędkość obrotową',
                    'Zvolte otáčky'
                ]
            },            
            'title': [
                'Motor selection',
                'Motorauswahl',
                'SELECCIÓN DEL MOTOR',
                'CHOIX DU MOTEUR',
                'SCELTA DEL MOTORE',
                'SELEÇÃO DO MOTOR',
                '电机选型',
                'MOTOR SEÇİMİ',
                'MOTORSELECTIE',
                'WYBÓR SILNIKA',
                'VOLBA MOTORU'
            ],
            'motorSelectionCaps': [
                'MOTOR SELECTION',
                'MOTORAUSWAHL',
                'SELECCIÓN DEL MOTOR',
                'CHOIX DU MOTEUR',
                'SCELTA DEL MOTORE',
                'SELEÇÃO DO MOTOR',
                '电机选型',
                'MOTOR SEÇİMİ',
                'MOTORSELECTIE',
                'WYBÓR SILNIKA',
                'VOLBA MOTORU'
            ],
            'lineFrequency': [
                'Line frequency [Hz]',
                'Netzfrequenz [Hz]',
                'Frecuencia de red [Hz]',
                'Fréquence réseau [Hz]',
                'Frequenza di rete [Hz]',
                'Frequência de rede [Hz]',
                '电网频率 [Hz]',
                'Şebeke frekansı [Hz]',
                'Netfrequentie [Hz]',
                'Częstotliwość sieci [Hz]',
                'Frekvence sítě [Hz]'
            ],
            'lineVoltage': [
                'Line voltage [V]',
                'Netzspannung [V]',
                'Tensión de red [V]',
                'Tension réseau [V]',
                'Tensione di rete [V]',
                'Tensão de rede [V]',
                '电网电压 [V]',
                'Şebeke gerilimi [V]',
                'Netspanning [V]',
                'Napięcie sieci [V]',
                'Síťové napětí [V]'
            ],
            'efficiencyClass': [
                'Efficiency class',
                'Wirkungsdragklasse',
                'Clase de eficiencia',
                'Classe de rendement',
                'Classe di efficienza',
                'Classe do grau de eficiência',
                '能效等级',
                'Verim sınıfı',
                'Werkingsdraagklasse',
                'Klasa sprawności',
                'Třída účinnosti'
            ],
            'speed': [
                'Speed [rpm]',
                'Drehzahl [1/min]',
                'Velocidad [1/min]',
                'Vitesse [tr/min]',
                'Numero di giri [1/min]',
                'Rotações [1/min]',
                '转速 [RPM]',
                'Devir sayısı [1/dak]',
                'Toerental [1/min]',
                'Prędkość obrotowa [1/min]',
                'Otáčky [ot/min]'
            ],
            'ratedPowerBasedOn': [
                'Rated power based on [Hz]',
                'Bemessungsleistung basierend auf [Hz]',
                'Potencia asignada basada en [Hz]',
                'Puissance assignée basée sur [Hz]',
                'Potenza nominale basata su [Hz]',
                'Potência de referência com base em [Hz]',
                '额定功率，基于 [Hz]',
                '[Hz] bazında nominal güç',
                'Nominaal vermogen gebaseerd op [Hz]',
                'Moc znamionowa w oparciu o [Hz]',
                'Jmenovitý výkon na základě [Hz]'
            ],
            'ratedPower': [
                'Rated power',
                'Bemessungsleistung',
                'Potencia asignada',
                'Puissance assignée',
                'Potenza nominale',
                'Potência de referência',
                '额定功率',
                'Nominal güç',
                'Nominaal vermogen',
                'Moc znamionowa',
                'Jmenovitý výkon'
            ],
            'frameMaterial': {
                'title': [
                    'Frame material',
                    'Gehäusematerial',
                    'Material de la carcasa',
                    'Matériau de la carcasse',
                    'Materiale dell\'involucro',
                    'Material do invólucro',
                    '外壳材料',
                    'Gövde malzemesi',
                    'Behuizingsmateriaal',
                    'Materiał obudowy',
                    'Materiál krytu'
                ],
                'castiron': [
                    'Cast iron',
                    'Grauguss',
                    'Fundición gris',
                    'Fonte grise',
                    'Ghisa grigia',
                    'Ferro fundido',
                    '灰铸铁',
                    'Gri döküm demir',
                    'Ruwijzer',
                    'Żeliwo szare',
                    'Šedá litina'
                ],
                'aluminium': [
                    'Aluminium',
                    'Aluminium',
                    'Aluminio',
                    'Aluminium',
                    'Alluminio',
                    'Alumínio',
                    '铝',
                    'Alüminyum',
                    'Aluminium',
                    'Aluminium',
                    'Hliník'
                ]
            },
            'motorType': [
                'Motor type',
                'Ausführung',
                'Versión',
                'Exécution',
                'Esecuzione',
                'Modelo',
                '电机规格',
                'Model',
                'Uitvoering',
                'Wykonanie',
                'Provedení'
            ],
            'frameSize': [
                'Frame size',
                'Baugröße',
                'Tamaño',
                'Taille',
                'Grandezza costruttiva',
                'Tamanho da estrutura',
                '外形尺寸',
                'Boyut',
                'Bouwgrootte',
                'Wielkość mechaniczna',
                'Konstrukční velikost'
            ],
            'mlfb': [
                'MLFB',
                'MLFB',
                'Referencia MLFB',
                'Nº de référence',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB'
            ],
            'explosionProtection': {
                'title': [
                    'Explosion protection (Zone)',
                    'Zündschutzart (Zone)',
                    'Modo de protección (zona)',
                    'Mode de protection (zone)',
                    'Modo di protezione antideflagrante (zona)',
                    'Tipo de proteção (zona)',
                    '防爆型式（区域）',
                    'Kıvılcım koruması türü (bölge)',
                    'Veiligheidsklasse (zone)',
                    'Ochrona przeciwwybuchowa (strefa)',
                    'Druh ochrany proti výbuchu (zóna)'
                ],
                'safearea': [
                    'without (Safe Area)',
                    'ohne (Safe Area)',
                    'sin (Safe Area)',
                    'sans (safe area)',
                    'senza (Safe Area)',
                    'sem (Safe Area)',
                    '无（安全区域）',
                    'yok (Safe Area)',
                    'zonder (Safe Area)',
                    'bez (Safe Area)',
                    'bez (bezpečná oblast)'
                ]
            }
        },
        'operationalData': {
            'title': [
                'STARTING CONSTRAINTS & OPERATIONAL DATA',
                'ANLAUFBEDINGUNGEN & BETRIEBSDATEN',
                'CONDICIONES DE ARRANQUE Y DATOS OPERATIVOS',
                'CONDITIONS DE DÉMARRAGE & DONNÉES D\'EXPLOITATION',
                'CONDIZIONI DI AVVIAMENTO E DATI DI ESERCIZIO',
                'CONDIÇÕES DE ARRANQUE & DADOS DE OPERAÇÃO',
                '启动条件 & 运行数据',
                'BAŞLATMA KOŞULLARI VE İŞLETİM VERİLERİ',
                'STARTVOORWAARDEN & BEDRIJFSGEGEVENS',
                'WARUNKI ROZRUCHU I DANE EKSPLOATACYJNE',
                'PODMÍNKY PRO ROZBĚH A PROVOZNÍ ÚDAJE'
            ],
            'startUpPossible': [
                'Start-up possible',
                'Anlauf möglich',
                'Arranque posible',
                'Démarrage possible',
                'Avviamento possibile',
                'É possível realizar arranque',
                '可启动',
                'Başlatma olanaklı',
                'Starten niet mogelijk',
                'Rozruch możliwy',
                'Rozběh je možný'
            ],
            'startUpNotPossible': [
                'Start-up not possible',
                'Anlauf nicht möglich',
                'Arranque no posible',
                'Démarrage impossible',
                'Avviamento non possibile',
                'Não é possível realizar arranque',
                '无法启动',
                'Başlatma olanaklı değil',
                'Starten niet mogelijk',
                'Rozruch nie jest możliwy',
                'Rozběh není možný'
            ],
            'startingConstraints': {
                'title': [
                    'Starting constraints',
                    'Anlaufbedingungen',
                    'Condiciones de arranque',
                    'Conditions de démarrage',
                    'Condizioni di avviamento',
                    'Condições de arranque',
                    '启动条件',
                    'Başlatma koşulları',
                    'Startvoorwaarden',
                    'Warunki rozruchu',
                    'Rozběhové podmínky'
                ],
                'startingVoltage': [
                    'Starting voltage',
                    'Anlaufspannung',
                    'Tensión de arranque',
                    'Tension au démarrage',
                    'Tensione di avviamento',
                    'Tensão de arranque',
                    '启动电压',
                    'Başlatma gerilimi',
                    'Startspanning',
                    'Napięcie rozruchowe',
                    'Rozběhové napětí'
                ],
                'tolerance': {
                    'title': [
                        'Tolerance',
                        'Toleranz',
                        'Tolerancia',
                        'Tolérance',
                        'Tolleranza',
                        'Tolerância',
                        '公差',
                        'Tolerans',
                        'Tolerantie',
                        'Tolerancja',
                        'Tolerance'
                    ],
                    'withTolerance': [
                        'With tolerance',
                        'Mit Toleranz',
                        'Con tolerancia',
                        'Avec tolérance',
                        'Con tolleranza',
                        'Com tolerância',
                        '带公差',
                        'Toleranslı',
                        'Met tolerantie',
                        'Z tolerancją',
                        'S tolerancí'
                    ],
                    'withoutTolerance': [
                        'Without tolerance',
                        'Ohne Toleranz',
                        'Sin tolerancia',
                        'Sans tolérance',
                        'Senza tolleranza',
                        'Sem tolerância',
                        '无公差',
                        'Toleranssız',
                        'Zonder tolerantie',
                        'Bez tolerancji',
                        'Bez tolerance'
                    ]
                },
                'startingCondition': {
                    'title': [
                        'Starting condition',
                        'Anlaufbedingungen',
                        'Condiciones de arranque',
                        'Conditions de démarrage',
                        'Condizioni di avviamento',
                        'Condições de arranque',
                        '启动条件',
                        'Başlatma koşulları',
                        'Startvoorwaarden',
                        'Warunki rozruchu',
                        'Rozběhové podmínky'
                    ],
                    'Cold': [
                        'Cold',
                        'Kalt',
                        'En frío',
                        'Froid',
                        'A freddo',
                        'Frio',
                        '冷',
                        'Soğuk',
                        'Koud',
                        'Zimny',
                        'Za studena'
                    ],
                    'Warm': [
                        'Warm',
                        'Warm',
                        'En caliente',
                        'Chaud',
                        'A caldo',
                        'Quente',
                        '热',
                        'Sıcak',
                        'Warm',
                        'Ciepły',
                        'Za tepla'
                    ]
                },
                'numberOfStartUps': {
                    'title': [
                        'Number of start-ups',
                        'Anzahl der Anläufe',
                        'Número de arranques',
                        'Nombre de démarrages',
                        'Numero di avviamenti',
                        'Número de arranques',
                        '启动次数',
                        'Başlatma sayısı',
                        'Aantal starts',
                        'Liczba rozruchów',
                        'Počet rozběhů'
                    ],
                    'text': [
                        'According to IEC 60034-12 (cold / warm): 2 / 1',
                        'Gemäß IEC 60034-12 (kalt / warm): 2 / 1',
                        'Según IEC 60034-12 (frío/caliente): 2 / 1',
                        'Selon IEC 60034-12 (à froid / à chaud) : 2 / 1',
                        'Secondo IEC 60034-12 (a freddo / a caldo): 2 / 1',
                        'Conforme IEC 60034-12 (frio / quente): 2 / 1',
                        '根据 IEC 60034-12（冷/热）2 / 1',
                        'IEC 60034-12\'ye göre(soğuk / sıcak): 2 / 1',
                        'Volgens IEC 60034-12 (koud / warm): 2 / 1',
                        'Zgodnie z IEC 60034-12 (zimny / ciepły): 2 / 1',
                        'Podle normy IEC 60034-12 (za studena/za tepla): 2 / 1'
                    ]
                },
                'ac': [
                    'Number of start-ups (cold)',
                    'Anzahl der Anläufe (kalt)',
                    'Número de arranques (en frío)',
                    'Nombre de démarrages (à froid)',
                    'Numero di avviamenti (a freddo)',
                    'Número de arranques (frio)',
                    '启动次数（冷）',
                    'Başlatma sayısı (soğuk)',
                    'Aantal starts (koud)',
                    'Liczba rozruchów (zimny)',
                    'Počet rozběhů (za studena)'
                ],
                'aw': [
                    'Number of start-ups (warm)',
                    'Anzahl der Anläufe (warm)',
                    'Número de arranques (en caliente)',
                    'Nombre de démarrages (à chaud)',
                    'Numero di avviamenti (a caldo)',
                    'Número de arranques (quente)',
                    '启动次数（热）',
                    'Başlatma sayısı (sıcak)',
                    'Aantal starts (warm)',
                    'Liczba rozruchów (ciepły)',
                    'Počet rozběhů (za tepla)'
                ],
                'startingVoltageConditionalMessage': [
                    'Motor application is also possible for higher line voltage',
                    'Motorbetrieb auch bei höherer Netzspannung möglich',
                    'Funcionamiento del motor también posible con mayor tensión de red',
                    'Fonctionnement du moteur possible même avec une tension réseau plus élevée',
                    'Funzionamento del motore possibile anche con una tensione di rete superiore',
                    'Operação do motor também é possível com tensão de rede maior',
                    '电机也可在更高的电网电压下运行',
                    'Motorun, daha yüksek şebeke gerilimi ile işletimi de olanaklıdır',
                    'Motorbedrijf ook bij hogere netspanning mogelijk',
                    'Praca silnikowa możliwa również przy wyższym napięciu sieci',
                    'Motorický režim je možný i při vyšším síťovém napětí'
                ],
                'temperatureClass': {
                    'title': [
                        'Temperature class',
                        'Temperaturklasse',
                        'Clase de temperatura',
                        'Classe de température',
                        'Classe di temperatura',
                        'Classe de temperatura',
                        '温度等级',
                        'Sıcaklık sınıfı',
                        'Temperatuurklasse',
                        'Klasa temperaturowa',
                        'Teplotní třída'
                    ],
                    'T1T2': [
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2',
                        'T1/T2'
                    ],
                    'T3': [
                        'T3',
                        'T3',
                        'T3',
                        'T3',
                        'T3',
                        'T3',
                        'T3',
                        'T3',
                        'T3',
                        'T3',
                        'T3'
                    ],
                    'HeatingTimeT3': [
                        'Heating time |tE| T3',
                        'Erwärnungszeit |tE| T3',
                        'Tiempo de calentamiento |tE| T3',
                        'Temps de chauffage |tE| T3',
                        'Tempo di riscaldamento |tE| T3',
                        'Tempo de aquecimento |tE| T3',
                        '加热时间 |tE| T3',
                        'Isınma süresi |tE| T3',
                        'Opwarmingstijd |tE| T3',
                        'Czas nagrzewania |tE| T3',
                        'Doba zahřátí |tE| T3'
                    ],
                    'HeatingTimeT1T2': [
                        'Heating time |tE| T1/T2',
                        'Erwärnungszeit |tE| T1/T2',
                        'Tiempo de calentamiento |tE| T1/T2',
                        'Temps de chauffage |tE| T1/T2',
                        'Tempo di riscaldamento |tE| T1/T2',
                        'Tempo de aquecimento |tE| T1/T2',
                        '加热时间 |tE| T1/T2',
                        'Isınma süresi |tE| T1/T2',
                        'Opwarmingstijd |tE| T1/T2',
                        'Czas nagrzewania |tE| T1/T2',
                        'Doba zahřátí |tE| T1/T2'
                    ]
                },
                'startingType': {
                    'title': [
                        'Starting type',
                        'Anlaufmethode',
                        'Método de arranque',
                        'Méthode de démarrage',
                        'Metodo di avviamento',
                        'Método de arranque',
                        '启动方式',
                        'Başlatma yöntemi',
                        'Startmethode',
                        'Typ rozruchu',
                        'Metoda rozběhu'
                    ],
                    'DOL': [
                        'Direct online (DOL)',
                        'Direktanlauf (DOL)',
                        'Arranque directo (DOL)',
                        'Démarrage direct (DOL)',
                        'Avviamento diretto (DOL)',
                        'Arranque direto (DOL)',
                        '直接启动 (DOL)',
                        'Doğrudan başlatma (DOL)',
                        'Directe start (DOL)',
                        'Rozruch bezpośredni (DOL)',
                        'Přímý rozběh (DOL)'
                    ],
                    'YD': [
                        'Star-Delta (Y/D)',
                        'Stern-Dreieck Anlauf (Y/D)',
                        'Arranque en estrella-triángulo (Y/D)',
                        'Démarrage étoile-triangle (Y/D)',
                        'Avviamento stella-triangolo (Y/D)',
                        'Arranque estrela-triângulo (Y/D)',
                        '星形/三角形启动 (Y/D)',
                        'Yıldız-delta başlatma (Y/D)',
                        'Ster-driehoek start (Y/D)',
                        'Rozruch gwiazda-trójkąt (Y/D)',
                        'Rozběh s přepínáním hvězda-trojúhelník (Y/D)'
                    ]
                }
            },
            'loadPointsSpeed': {
                'title': [
                    'Load points speed (motor shaft)',
                    'Lastdrehzahl Punkte (Motorwelle)',
                    'Puntos de velocidad bajo carga (eje de motor)',
                    'Vitesse de charge Points (arbre du moteur)',
                    'Punti del numero di giro del carico (albero motore)',
                    'Rotações de carga (eixo do motor)',
                    '负载点转速（电机转轴）',
                    'Yük eğrisi noktaları (motor mili)',
                    'Lasttoerental punten (Motoras)',
                    'Punkty prędkości obrotowej pod obciążeniem (wał silnika)',
                    'Otáčky pod zatížením v pracovním bodě (hřídel motoru)'
                ],
                'n0': [
                    'n0 [rpm]',
                    'n0 [1/min]',
                    'n0 [1/min]',
                    'n0 [tr/min]',
                    'n0 [1/min]',
                    'n0 [1/min]',
                    'n0 [rpm]',
                    'n0 [1/dak]',
                    'n0 [1/min]',
                    'n0 [1/min]',
                    'n0 [ot/min]'
                ],
                'n1': [
                    'n1 [rpm]',
                    'n1 [1/min]',
                    'n1 [1/min]',
                    'n1 [tr/min]',
                    'n1 [1/min]',
                    'n1 [1/min]',
                    'n1 [rpm]',
                    'n1 [1/dak]',
                    'n1 [1/min]',
                    'n1 [1/min]',
                    'n1 [ot/min]'
                ],
                'n2': [
                    'n2 [rpm]',
                    'n2 [1/min]',
                    'n2 [1/min]',
                    'n2 [tr/min]',
                    'n2 [1/min]',
                    'n2 [1/min]',
                    'n2 [rpm]',
                    'n2 [1/dak]',
                    'n2 [1/min]',
                    'n2 [1/min]',
                    'n2 [ot/min]'
                ],
                'n3': [
                    'n3 [rpm]',
                    'n3 [1/min]',
                    'n3 [1/min]',
                    'n3 [tr/min]',
                    'n3 [1/min]',
                    'n3 [1/min]',
                    'n3 [rpm]',
                    'n3 [1/dak]',
                    'n3 [1/min]',
                    'n3 [1/min]',
                    'n3 [ot/min]'
                ],
                'n4': [
                    'Operating speed [rpm]',
                    'Betriebsdrehzahl [1/min]',
                    'Velocidad de operación [1/min]',
                    'Vitesse de fonctionnement [tr/min]',
                    'Numero di giri di esercizio [1/min]',
                    'Rotações de referência [1/min]',
                    '运行转速 [rpm]',
                    'İşletim devir sayısı [1/dak]',
                    'Bedrijfstoerental [1/min]',
                    'Robocza prędkość obrotowa [1/min]',
                    'Provozní otáčky [ot/min]'
                ]
            },
            'loadPointsTorque': {
                'title': [
                    'Load points torque (motor shaft)',
                    'Lastmoment Punkte (Motorwelle)',
                    'Puntos de par de carga (eje de motor)',
                    'Couple de charge Points (arbre du moteur)',
                    'Punti della coppia di carico (albero motore)',
                    'Binário de carga pontos (eixo do motor)',
                    '负载点转矩（电机转轴）',
                    'Yük momenti noktaları (motor mili)',
                    'Lastmoment punten (Motoras)',
                    'Punkty momentu pod obciążeniem (wał silnika)',
                    'Moment pod zatížením v pracovním bodě (hřídel motoru)'
                ],
                'm0': [
                    'M0',
                    'M0',
                    'M0',
                    'M0',
                    'M0',
                    'M0',
                    'M0',
                    'M0',
                    'M0',
                    'M0',
                    'M0'
                ],
                'm1': [
                    'M1',
                    'M1',
                    'M1',
                    'M1',
                    'M1',
                    'M1',
                    'M1',
                    'M1',
                    'M1',
                    'M1',
                    'M1'
                ],
                'm2': [
                    'M2',
                    'M2',
                    'M2',
                    'M2',
                    'M2',
                    'M2',
                    'M2',
                    'M2',
                    'M2',
                    'M2',
                    'M2'
                ],
                'm3': [
                    'M3',
                    'M3',
                    'M3',
                    'M3',
                    'M3',
                    'M3',
                    'M3',
                    'M3',
                    'M3',
                    'M3',
                    'M3'
                ],
                'm4': [
                    'Operating torque',
                    'Betriebsmoment',
                    'Par de empleo',
                    'Couple de fonctionnement',
                    'Coppia di esercizio',
                    'Binário de operação',
                    '运行转矩',
                    'İşletim momenti',
                    'Bedrijfsmoment',
                    'Moment roboczy',
                    'Moment za provozu'
                ]
            },
            'loadCoupling': {
                'title': [
                    'Load coupling',
                    'Lastkupplungsart',
                    'Tipo de acoplamiento de la carga',
                    'Type d\'accouplement de charge',
                    'Tipo di accoppiamento del carico',
                    'Tipo de acoplamento de carga',
                    '负载连接方式',
                    'Yük bağlantı türü',
                    'Lastkoppelingstype',
                    'Rodzaj sprzęgła obciążenia',
                    'Způsob připojení zátěže'
                ],                
                'motorInertia': [
                    'Motor moment of inertia',
                    'Läuferträgheitsmoment',
                    'Momento de inercia del rotor',
                    'Couple d\'inertie du rotor',
                    'Momento d\'inerzia del rotore',
                    'Binário de inércia do rotor',
                    '电机转子转动惯量',
                    'Rotor atalet momenti',
                    'Rotortraagheidsmoment',
                    'Moment bezwładności wirnika',
                    'Moment setrvačnosti rotoru'
                ],
                'n1': [
                    'n1 [rpm]',
                    'n1 [1/min]',
                    'n1 [1/min]',
                    'n1 [tr/min]',
                    'n1 [1/min]',
                    'n1 [1/min]',
                    'n1 [rpm]',
                    'n1 [1/dak]',
                    'n1 [1/min]',
                    'n1 [1/min]',
                    'n1 [ot/min]'
                ],
                'gearboxInertia': [
                    'Gearbox moment of inertia',
                    'Trägheitmoment des Getriebes',
                    'Momento de inercia del reductor',
                    'Moment d\'inertie du réducteur',
                    'Momento d\'inerzia del riduttore',
                    'Binário de inércia da engrenagem',
                    '齿轮箱转动惯量',
                    'Dişlinin eylemsizlik momenti',
                    'Traagheidsmoment van de transmissie',
                    'Moment bezwładności przekładni',
                    'Moment setrvačnosti převodovky'
                ],
                'n2': [
                    'n2 [rpm] (gearbox and load)',
                    'n2 [1/min] (Getriebe und Last)',
                    'n2 [1/min] (reductor y carga)',
                    'n2 [tr/min] (réducteur et charge)',
                    'n2 [1/min] (riduttore e carico)',
                    'n2 [1/min] (engrenagem e carga)',
                    'n2 [rpm]（齿轮箱和负载）',
                    'n2 [1/dak] (dişli ve yük)',
                    'n2 [1/min] (Transmissie en last)',
                    'n2 [1/min] (przekładnia i obciążenie)',
                    'n2 [ot/min] (převodovka a zátěž)'
                ],
                'loadInertia': [
                    'Load moment of inertia',
                    'Lastträgheitsmoment',
                    'Momento de inercia de la carga',
                    'Couple d\'inertie de la charge',
                    'Momento d\'inerzia del carico',
                    'Binário de inércia de carga',
                    '负载转动惯量',
                    'Yük eylemsizlik momenti',
                    'Laststraagheidsmoment',
                    'Moment bezwładności obciążenia',
                    'Moment setrvačnosti zátěže'
                ],
                'motorDriveConnection': {
                    'title': [
                        'Connection between motor and drive',
                        'Mechanischer Anschluss des Antriebssystems',
                        'Conexión mecánica del sistema de accionamiento',
                        'Raccordement mécanique du système d\'entraînement',
                        'Collegamento meccanico del sistema di azionamento',
                        'Ligação mecânica do sistema de acionamento',
                        '驱动系统的机械连接',
                        'Tahrik sisteminin mekanik bağlantısı',
                        'Mechanische aansluiting van het aandrijfsysteem',
                        'Połączenie mechaniczne układu napędowego',
                        'Mechanické připojení systému pohonu'
                    ],
                    'WithGearbox': [
                        'With gearbox or belt',
                        'Mit Getriebe oder Riemen',
                        'Con reductor o correa',
                        'Avec réducteur ou courroie',
                        'Con riduttore o cinghia',
                        'Com engrenagem ou correia',
                        '带齿轮箱或皮带',
                        'Dişli veya kayış ile',
                        'Met transmissie of riemen',
                        'Z przekładnią lub paskiem',
                        'S převodovkou nebo řemenicí'
                    ],
                    'Direct': [
                        'Directly coupled',
                        'Direktgekuppelt',
                        'Con acoplamiento directo',
                        'À accouplement direct',
                        'Accoppiato direttamente',
                        'Acoplado direto',
                        '直接连接',
                        'Doğrudan akuple',
                        'Direct gekoppeld',
                        'Bezpośrednio sprzężony',
                        'S přímým spojením'
                    ]
                }
            },
            'loadPoints': {
                'loadType': {
                    'title': [
                        'Load type',
                        'Lastkennlinie',
                        'Curva característica de carga',
                        'Caractéristique de charge',
                        'Curva caratteristica del carico',
                        'Curva caraterística de carga',
                        '负载特性曲线',
                        'Yük eğrisi',
                        'Lastkarakteristiek',
                        'Charakterystyka obciążenia',
                        'Charakteristika zatížení'
                    ],
                    'QuadraticWithoutBreakaway': [
                        'Quadratic - without breakaway',
                        'Quadratisch ohne Losbrechmoment',
                        'Cuadrático sin par de despegue',
                        'Carré sans couple de décollage',
                        'Quadratico senza coppia di distacco',
                        'Quadrado sem torque de partida',
                        '平方，无起步转矩',
                        'Demeraj torksuz olarak karesel',
                        'Kwadratisch zonder losbreekmoment',
                        'Kwadratowy - bez momentu przełamania',
                        'Kvadraticky bez momentu při odtržení'
                    ],
                    'QuadraticWithBreakaway': [
                        'Quadratic - with breakaway',
                        'Quadratisch mit Losbrechmoment',
                        'Cuadrático con par de despegue',
                        'Carré avec couple de décollage',
                        'Quadratico con coppia di distacco',
                        'Quadrado com torque de partida',
                        '平方，带起步转矩',
                        'Demeraj torklu olarak karesel',
                        'Kwadratisch met losbreekmoment',
                        'Kwadratowy - z momentem przełamania',
                        'Kvadraticky s momentem při odtržení'
                    ],
                    'Constant': [
                        'Constant',
                        'Konstant',
                        'Constante',
                        'Constant',
                        'Costante',
                        'Constante',
                        '恒定',
                        'Sabit',
                        'Constant',
                        'Stały',
                        'Konstantní'
                    ],
                    'Linear': [
                        'Linear',
                        'Linear',
                        'Lineal',
                        'Linéaire',
                        'Lineare',
                        'Linear',
                        '线性',
                        'Doğrusal',
                        'Lineair',
                        'Liniowy',
                        'Lineární'
                    ],
                    'NoLoad': [
                        'No load',
                        'Unbelastet',
                        'Sin carga',
                        'Sans charge',
                        'Senza carico',
                        'Sem carga',
                        '空载',
                        'Yüksüz',
                        'Onbelast',
                        'Nieobciążony',
                        'Bez zatížení'
                    ],
                    'Custom': [
                        'Custom',
                        'Benutzerdefiniert',
                        'Personalizado',
                        'Personnalisé',
                        'Definito dall\'utente',
                        'Personalizado',
                        '用户自定义',
                        'Kullanıcı tanımlı',
                        'Gedefinieerd door gebruiker',
                        'Definiowany przez użytkownika',
                        'Definovaný uživatelem'
                    ]
                }                
            }
        },
        'resul': {
            'title': [
                'RESULT SUMMARY',
                'ZUSAMMENFASSUNG DER ERGEBNISSE',
                'RESUMEN DE LOS RESULTADOS',
                'RÉSUMÉ DES RÉSULTATS',
                'RIEPILOGO DEI RISULTATI',
                'RESUMO DOS RESULTADOS',
                '结论摘要',
                'SONUÇLARIN ÖZETİ',
                'SAMENVATTING VAN DE RESULTATEN',
                'PODSUMOWANIE WYNIKÓW',
                'SHRNUTÍ VÝSLEDKŮ'
            ],
            'exEbIIC': [
                'Please check the results of the simulation with the restrictions of the standards DIN EN60079.',
                'Bitte prüfen Sie die Simulationsergebnisse mit den Beschränkungen der Normen DIN EN60079.',
                'Compruebe los resultados de la simulación con las restricciones de las normas DIN EN60079.',
                'Vérifier les résultats de la simulation avec les restrictions des normes EN 60079.',
                'Verificare i risultati della simulazione rispetto a limiti delle norme DIN EN 60079.',
                'Compare os resultados de simulação com as restrições das normas DIN EN60079.',
                '请查看根据标准 DIN EN60079 的要求进行的仿真结果。',
                'Lütfen benzetim sonuçlarını DIN EN60079 standardının kısıtlamalarıyla kontrol ediniz.',
                'Controleer de simulatieresultaten met de beperkingen van de normen DIN EN60079.',
                'Proszę sprawdzić wyniki symulacji z ograniczeniami normy DIN EN60079.',
                'Zkontrolujte prosím výsledky simulace s omezeními danými normou DIN EN60079.'
            ]
        }
    },
    'diagram': {        
        'enableDrag': [
            'Enable drag',
            'Verschieben aktivieren',
            'Activar el desplazamiento',
            'Activer le décalage',
            'Attivare lo spostamento',
            'Ativar deslocar',
            '启用拖动功能',
            'Sürgüyü etkinleştirin',
            'Verschuiven activeren',
            'Włącz przesunięcie',
            'Aktivování posunutí'
        ],
        'enableZoom': [
            'Enable zoom',
            'Vergrößerung aktivieren',
            'Activar el aumento',
            'Activer l\'agrandissement',
            'Attivare l\'ingrandimento',
            'Ativar aumento',
            '启用放大功能',
            'Büyütmeyi etkinleştirin',
            'Vergroting activeren',
            'Włącz powiększenie',
            'Aktivování zvětšení'
        ],
        'resetZoom': [
            'Reset zoom',
            'Vergrößerung zurücksetzen',
            'Deshacer el aumento',
            'Réinitialiser l\'agrandissement',
            'Azzerare l\'ingrandimento',
            'Repor aumento',
            '取消放大',
            'Büyütmeyi sıfırlayın',
            'Vergroting resetten',
            'Zresetuj powiększenie',
            'Vrácení zvětšení zpět'
        ],
        'thumbnail': {
            'torqueOverSpeed': [
                'Torque Over Speed',
                'Drehmoment über Drehzahl',
                'Par en función de la velocidad',
                'Couple en fonction de la vitesse',
                'Coppia su numero di giri',
                'Binário através de rotações',
                '转矩与转速的关系',
                'Torka göre devir sayısı',
                'Draaimoment over toerental',
                'Moment obrotowy w funkcji prędkości obrotowej',
                'Moment vůči otáčkám'
            ],
            'currentOverSpeed': [
                'Current Over Speed',
                'Strom über Drehzahl',
                'Corriente en función de la velocidad',
                'Courant en fonction de la vitesse',
                'Corrente su velocità',
                'Corrente através de rotações',
                '电流与转速的关系',
                'Akıma göre devir sayısı',
                'Stroom over toerental',
                'Prąd w funkcji prędkości obrotowej',
                'Proud vůči otáčkám'
            ],
            'currentOverTime': [
                'Current Over Time',
                'Strom über Zeit',
                'Corriente en función del tiempo',
                'Courant en fonction du temps',
                'Corrente su tempo',
                'Corrente através de tempo',
                '电流与时间的关系',
                'Akıma göre zaman',
                'Stroom over tijd',
                'Prąd w czasie',
                'Proud vůči času'
            ],
            'powerOverSpeed': [
                'Power Over Speed',
                'Leistung über Drehzahl',
                'Potencia en función de la velocidad',
                'Puissance en fonction de la vitesse',
                'Potenza su numero di giri',
                'Potência através de rotações',
                '功率与转速的关系',
                'Güce göre devir sayısı',
                'Vermogen over toerental',
                'Moc w funkcji prędkości obrotowej',
                'Výkon vůči otáčkám'
            ],
            'timeOverSpeed': [
                'Time Over Speed',
                'Zeit über Drehzahl',
                'Tiempo en función de la velocidad',
                'Temps en fonction de la vitesse',
                'Tempo su velocità',
                'Tempo através de rotações',
                '时间与转速的关系',
                'Zamana göre devir sayısı',
                'Tijd over toerental',
                'Czas w funkcji prędkości obrotowej',
                'Čas vůči otáčkám'
            ],
            'converterOperationVsd': [
                'Converter Operation',
                'Umrichterbetrieb',
                'Alimentación por convertidor',
                'Fonctionnement avec variateur',
                'Funzionamento con convertitore',
                'Modo do conversor',
                '变频运行',
                'Dönüştürücü işletimi',
                'Omvormerbedrijf',
                'Praca z przekształtnikiem',
                'Provoz s měničem'
            ]
        },
        'scaling': {
            'title': [
                'Scaling',
                'Skalierung',
                'Escalado',
                'Normalisation',
                'Scalatura',
                'Escalação',
                '定标',
                'Ölçeklendirme',
                'Schaalverdeling',
                'Skalowanie',
                'Změna měřítka'
            ],
            'absoluteScaling': [
                'Absolute values',
                'Absolutwerte',
                'Valores absolutos',
                'Valeurs absolues',
                'Valori assoluti',
                'Valores absoluto',
                '绝对值',
                'Mutlak değerler',
                'Absolute waarde',
                'Wartości absolutne',
                'Absolutní hodnoty'
            ],
            'relatedScaling': [
                'Related values',
                'Bezogene Werte',
                'Valores relacionados',
                'Valeurs de référence',
                'Valori relativi',
                'Valores de referência',
                '参考值',
                'İlgili değerler',
                'Relatieve waarde',
                'Wartości odniesienia',
                'Vztažné hodnoty'
            ]
        },
        'filter': {
            'title': [
                'Filters',
                'Filter',
                'Filtros',
                'Filtres',
                'Filtro',
                'Filtro',
                '滤波器',
                'Filtre',
                'Filter',
                'Filtry',
                'Filtr'
            ],
            'default': [
                'Default',
                'Standardwert',
                'Valor estándar',
                'Valeur standard',
                'Valore standard',
                'Valor padrão',
                '默认值',
                'Standart değer',
                'Standaardwaarde',
                'Wartość standardowa',
                'Standardní hodnota'
            ],
            'all': [
                'All',
                'Alle',
                'Todos',
                'Tous',
                'Tutti',
                'Tudo',
                '全部',
                'Tümü',
                'Alle',
                'Wszystkie',
                'Všechny'
            ],
            'power': [
                'Power',
                'Leistung',
                'Potencia',
                'Puissance',
                'Potenza',
                'Potência',
                '功率',
                'Güç',
                'Vermogen',
                'Moc',
                'Výkon'
            ]
        },
        'legend': {
            'specialPointLabel': {
                'ratedpoint': [
                    'Rated Point',
                    'Bemessungspunkt',
                    'Punto asignado',
                    'Point assigné',
                    'Punto nominale',
                    'Ponto de referência',
                    '额定运行点',
                    'Nominal nokta',
                    'Nominaal punt',
                    'Punkt znamionowy',
                    'Jmenovitý bod'
                ],
                'motoroperation': [
                    'Motor Operating Point',
                    'Motorbetriebspunkt',
                    'Punto de trabajo del motor',
                    'Point de fonctionnement du moteur',
                    'Punto operativo del motore',
                    'Ponto de operação do motor',
                    '电机运行点',
                    'Motor işletim noktası',
                    'Motorbedrijfspunt',
                    'Punkt pracy silnika',
                    'Pracovní bod motoru'
                ],
                'loadoperation': [
                    'Load Operating Point',
                    'Betriebspunkt der Last',
                    'Punto de trabajo de la carga',
                    'Point de fonctionnement de la charge',
                    'Punto operativo del carico',
                    'Ponto de operação da carga',
                    '负载运行点',
                    'Yük işletim noktası',
                    'Bedrijfspunt van de last',
                    'Punkt pracy obciążenia',
                    'Pracovní bod zátěže'
                ],
                'loadswitching': [
                    'Switching Point (Star/Delta)',
                    'Umschaltpunkt (Stern/Dreieck)',
                    'Punto de conmutación (estrella/triángulo)',
                    'Point de commutation (étoile/triangle)',
                    'Punto di commutazione (stella/triangolo)',
                    'Ponto de comutação (estrela/triângulo)',
                    '切换点（星形/三角形）',
                    'Anahtarlama noktası (yıldız/delta)',
                    'Omschakelpunt (ster/driehoek)',
                    'Punkt przełączenia (gwiazda/trójkąt)',
                    'Bod přepnutí (hvězda/trojúhelník)'
                ],
                'loadpower': [
                    'Load Power ${x} on the motor shaft (100% line voltage)',
                    'Lastleistung ${x} an der Motorwelle (100% Netz Spannung)',
                    'Potencia de la carga ${x} en el eje de motor (100% tensión de red)',
                    'Puissance de charge ${x} sur l\'arbre du moteur(100 % tension réseau)',
                    'Potenza di carico ${x} all\'albero motore(100 % della tensione di rete)',
                    'Potência de carga ${x} no eixo do motor (100% tensão de rede)',
                    '电机转轴上的负载功率 ${x}（100% 电网电压）',
                    'Motor milinde yük kapasitesi ${x} (%100 şebeke gerilimi)',
                    'Lastvermogen ${x} aan de motoras (100% netspanning)',
                    'Moc obciążenia ${x} na wale silnika (100% napięcia sieci)',
                    'Výkon odevzdávaný do zátěže ${x} na hřídeli motoru (napětí sítě 100%)'
                ]
            },
            'torqueoverspeed': [
                'Torque (100% Un)',
                'Drehmoment (100% Un)',
                'Par (100% Un)',
                'Couple (100 % Un)',
                'Coppia (100% Un)',
                'Binário (100% Un)',
                '转矩（100% Un）',
                'Tork (%100 Un)',
                'Draaimoment (100% Un)',
                'Moment obrotowy (100% Un)',
                'Točivý moment (100% Un)'
            ],
            'load': [
                'Load Torque',
                'Lastmoment',
                'Par de carga',
                'Couple résistant',
                'Coppia di carico',
                'Binário de carga',
                '负载转矩',
                'Yük momenti',
                'Lastmoment',
                'Moment obciążenia',
                'Moment zátěže'
            ],
            'limitcurve': [
                'Limit curve acc. IEC 60034-12',
                'Grenzkurve gem. IEC 60034-12',
                'Curva límite según IEC 60034-12',
                'Courbe limite selon IEC 60034-12',
                'Curva limite secondo IEC 60034-12',
                'Curva limite conforme IEC 60034-12',
                '符合IEC 60034-12 的极限曲线',
                'IEC 60034-12\'ye göre sınır eğrisi',
                'Grenscurve volgens IEC 60034-12',
                'Krzywa graniczna zg. z IEC 60034-12',
                'Mezní křivka podle IEC 60034-12'
            ],
            'accelerationtorque': [
                'Acceleration Torque (100% Un)',
                'Beschleunigungsmoment (100% Un)',
                'Par acelerador (100% Un)',
                'Couple d\'accélération(100 % Un)',
                'Coppia di accelerazione (100% Un)',
                'Binário de aceleração (100% Un)',
                '加速转矩 (100% Un)',
                'Hızlanma momenti (%100 Un)',
                'Versnellingsmoment (100% Un)',
                'Moment przyspieszeniowy (100% Un)',
                'Moment při zrychlování (100% Un)'
            ],
            'accelerationtorquewithspecificvoltage': [
                'Acceleration Torque (${x}% Un)',
                'Beschleunigungsmoment (${x}% Un)',
                'Par acelerador (${x}% Un)',
                'Couple d\'accélération(${ x } % Un)',
                'Coppia di accelerazione (${x}% Un)',
                'Binário de aceleração (${x}% Un)',
                '加速转矩 (${x}% Un)',
                'Hızlanma momenti (%${x} Un)',
                'Versnellingsmoment (${x}% Un)',
                'Moment przyspieszeniowy (${x}% Un)',
                'Moment při zrychlování (${x}% Un)'
            ],
            'currentoverspeed': [
                'Current (100% Un)',
                'Strom (100% Un)',
                'Corriente (100% Un)',
                'Courant (100 % Un)',
                'Corrente (100% Un)',
                'Corrente (100% Un)',
                '电流 (100% Un)',
                'Akım (%100 Un)',
                'Stroom (100% Un)',
                'Prąd (100% Un)',
                'Proud (100% Un)'
            ],
            'dolstardeltacurrent': [
                'Current (Star/Delta)',
                'Strom (Stern/Dreieck)',
                'Corriente (estrella/triángulo)',
                'Courant (étoile/triangle)',
                'Corrente (stella/triangolo)',
                'Corrente (estrela/triângulo)',
                '电流（星形/三角形）',
                'Akım (yıldız/delta)',
                'Stroom (ster/driehoek)',
                'Prąd (gwiazda/trójkąt)',
                'Proud (hvězda/trojúhelník)'
            ],
            'dolstardeltatorque': [
                'Torque (Star/Delta)',
                'Drehmoment (Stern/Dreieck)',
                'Par (estrella/triángulo)',
                'Couple (étoile/triangle)',
                'Coppia (stella/triangolo)',
                'Binário (estrela/triângulo)',
                '转矩（星形/三角形）',
                'Tork (yıldız/delta)',
                'Draaimoment (ster/driehoek)',
                'Moment obrotowy (gwiazda/trójkąt)',
                'Moment (hvězda/trojúhelník)'
            ],
            'loadpower': [
                'Load Power',
                'Lastleistung',
                'Potencia de la carga',
                'Puissance de charge',
                'Potenza di carico',
                'Potência de carga',
                '负载功率',
                'Yük kapasitesi',
                'Lastvermogen',
                'Moc obciążenia',
                'Výkon odevzdávaný do zátěže'
            ],
            'motorshaftpower': [
                'Motor Shaft Power (100% Un)',
                'Motorwellenleistung (100% Un)',
                'Potencia del eje de motor (100% Un)',
                'Puissance de l\'arbre du moteur(100 % Un)',
                'Potenza all\'albero motore(100 % Un)',
                'Potência do eixo do motor (100% Un)',
                '电机转轴功率 (100% Un)',
                'Motor mili kapasitesi (%100 Un)',
                'Motorasvermogen (100% Un)',
                'Moc na wale silnika (100% Un)',
                'Výkon na hřídeli motoru (100% Un)'
            ],
            'startuptime': [
                'Start-up time (100% Un)',
                'Anlaufzeit (100% Un)',
                'Tiempo de arranque (100% Un)',
                'Temps de démarrage (100 % Un)',
                'Tempo di avviamento (100% Un)',
                'Tempo de arranque (100% Un)',
                '启动时间 (100% Un)',
                'Başlatma süresi (%100 Un)',
                'Motorasvermogen (100% Un)',
                'Czas rozruchu (100% Un)',
                'Doba rozběhu (100% Un)'
            ],
            'torqueoverspeedwithspecificvoltage': [
                'Torque (${x}% Un)',
                'Drehmoment (${x}% Un)',
                'Par (${x}% Un)',
                'Couple (${x}% Un)',
                'Coppia (${x}% Un)',
                'Binário (${x}% Un)',
                '转矩 (${x}% Un)',
                'Tork (%${x} Un)',
                'Draaimoment (${x}% Un)',
                'Moment obrotowy (${x}% Un)',
                'Moment (${x}% Un)'
            ],
            'currentoverspeedwithspecificvoltage': [
                'Current (${x}% Un)',
                'Strom (${x}% Un)',
                'Corriente (${x}% Un)',
                'Courant (${x}% Un)',
                'Corrente (${x}% Un)',
                'Corrente (${x}% Un)',
                '电流 (${x}% Un)',
                'Akım (%${x} Un)',
                'Stroom (${x}% Un)',
                'Prąd (${x}% Un)',
                'Proud (${x}% Un)'
            ],
            'motorshaftpowerwithspecificvoltage': [
                'Motor Shaft Power (${x}% Un)',
                'Motorwellenleistung (${x}% Un)',
                'Potencia del eje de motor (${x}% Un)',
                'Puissance d\'arbre du moteur(${ x } % Un)',
                'Potenza all\'albero motore(${ x } % Un)',
                'Potência do eixo do motor (${x}% Un)',
                '电机转轴功率 (${x}% Un)',
                'Motor mili kapasitesi (%${x} Un)',
                'Motorasvermogen (${x}% Un)',
                'Moc na wale silnika (${x}% Un)',
                'Výkon na hřídeli motoru (${x}% Un)'
            ],
            'startuptimewithspecificvoltage': [
                'Start-up time (${x}% Un)',
                'Anlaufzeit (${x}% Un)',
                'Tiempo de arranque (${x}% Un)',
                'Temps de démarrage (${x}% Un)',
                'Tempo di avviamento (${x}% Un)',
                'Tempo de arranque (${x}% Un)',
                '启动时间 (${x}% Un)',
                'Başlatma süresi (%${x} Un)',
                'Starttijd (${x}% Un)',
                'Czas rozruchu (${x}% Un)',
                'Doba rozběhu (${x}% Un)'
            ],
            'startuptimewithyd': [
                'Start-up time (Star/Delta)',
                'Anlaufzeit (Stern/Dreieck)',
                'Tiempo de arranque (estrella/triángulo)',
                'Temps de démarrage (étoile/triangle)',
                'Tempo di avviamento (stella/triangolo)',
                'Tempo de arranque (estrela/triângulo)',
                '启动时间（星形/三角形）',
                'Başlatma süresi (yıldız / delta)',
                'Starttijd (ster/driehoek)',
                'Czas rozruchu (gwiazda/trójkąt)',
                'Doba rozběhu (hvězda/trojúhelník)'
            ],
            'currentovertimewithy': [
                'Current (Star)',
                'Strom (Stern)',
                'Corriente (estrella)',
                'Courant (étoile)',
                'Corrente (stella)',
                'Corrente (estrela)',
                '电流（星形）',
                'Akım (yıldız)',
                'Stroom (ster)',
                'Prąd (gwiazda)',
                'Proud (hvězda)'
            ],
            'currentovertimewithd': [
                'Current (Delta)',
                'Strom (Dreieck)',
                'Corriente (triángulo)',
                'Courant (triangle)',
                'Corrente (triangolo)',
                'Corrente (triângulo)',
                '电流（三角形）',
                'Akım (delta)',
                'Stroom (driehoek)',
                'Prąd (trójkąt)',
                'Proud (trojúhelník)'
            ],
            'currentovertimewithyd': [
                'Current (Star/Delta)',
                'Strom (Stern/Dreieck)',
                'Corriente (estrella/triángulo)',
                'Courant (étoile/triangle)',
                'Corrente (stella/triangolo)',
                'Corrente (estrela/triângulo)',
                '电流（星形/三角形）',
                'Akım (yıldız/delta)',
                'Stroom (ster/driehoek)',
                'Prąd (gwiazda/trójkąt)',
                'Proud (hvězda/trojúhelník)'
            ],
            'currentovertimewithywithspecificvoltage': [
                'Current Star (${x}% Un)',
                'Strom Stern (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)',
                'Current Star (${x}% Un)'
            ],
            'currentovertimewithdwithspecificvoltage': [
                'Current Delta (${x}% Un)',
                'Strom Dreieck (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)',
                'Current Delta (${x}% Un)'
            ],
            'torqueoverspeedwithspecificvoltageyd': [
                'Torque (Star)',
                'Drehmoment (Stern)',
                'Par (estrella)',
                'Couple (étoile)',
                'Coppia (stella)',
                'Binário (estrela)',
                '转矩（星形）',
                'Tork (yıldız)',
                'Draaimoment (Ster)',
                'Moment obrotowy (gwiazda)',
                'Moment (hvězda)'
            ],
            'accelerationtorquewithspecificvoltageyd': [
                'Acceleration Torque (Star/Delta)',
                'Beschleunigungsmoment (Stern/Dreieck)',
                'Par acelerador (estrella/triángulo)',
                'Couple d\'accélération(étoile / triangle)',
                'Coppia di accelerazione (stella/triangolo)',
                'Binário de aceleração (estrela/triângulo)',
                '加速转矩（星形/三角形）',
                'Hızlanma momenti (yıldız/delta)',
                'Versnellingsmoment (Ster/driehoek)',
                'Moment przyspieszeniowy (gwiazda/trójkąt)',
                'Moment zrychlení (hvězda/trojúhelník)'
            ],
            'vsdtorquelimit': [
                'Torque over Speed',
                'Drehmoment über Drehzahl',
                'Par en función de la velocidad',
                'Couple en fonction de la vitesse',
                'Coppia su numero di giri',
                'Binário através de rotações',
                '转矩与转速的关系',
                'Torka göre devir sayısı',
                'Draaimoment over toerental',
                'Moment obrotowy w funkcji prędkości obrotowej',
                'Moment vůči otáčkám'
            ],
            'vsdpowerlimit': [
                'Power over Speed',
                'Leistung über Drehzahl',
                'Potencia en función de la velocidad',
                'Puissance en fonction de la vitesse',
                'Potenza su numero di giri',
                'Potência através de rotações',
                '功率与转速的关系',
                'Güce göre devir sayısı',
                'Vermogen over toerental',
                'Moc w funkcji prędkości obrotowej',
                'Výkon vůči otáčkám'
            ],
            'torqueoverspeedyd': [
                'Torque (Delta)',
                'Drehmoment (Dreieck)',
                'Par (triángulo)',
                'Couple (triangle)',
                'Coppia (triangolo)',
                'Binário (triângulo)',
                '转矩（三角形）',
                'Tork (delta)',
                'Draaimoment (Driehoek)',
                'Moment obrotowy (trójkąt)',
                'Moment (trojúhelník)'
            ],
            'accelerationtorqueyd': [
                'Acceleration Torque (Delta)',
                'Beschleunigungsmoment (Dreieck)',
                'Par acelerador (triángulo)',
                'Couple d\'accélération(triangle)',
                'Coppia di accelerazione (triangolo)',
                'Binário de aceleração (triângulo)',
                '加速转矩（三角形）',
                'Hızlanma momenti (delta)',
                'Versnellingsmoment (Driehoek)',
                'Moment przyspieszeniowy (trójkąt)',
                'Moment zrychlení (trojúhelník)'
            ],
            'currentoverspeedyd': [
                'Current (Delta)',
                'Strom (Dreieck)',
                'Corriente (triángulo)',
                'Courant (triangle)',
                'Corrente (triangolo)',
                'Corrente (triângulo)',
                '电流（三角形）',
                'Akım (delta)',
                'Stroom (driehoek)',
                'Prąd (trójkąt)',
                'Proud (trojúhelník)'
            ],
            'currentoverspeedwithspecificvoltageyd': [
                'Current (Star)',
                'Strom (Stern)',
                'Corriente (estrella)',
                'Courant (étoile)',
                'Corrente (stella)',
                'Corrente (estrela)',
                '电流（星形）',
                'Akım (yıldız)',
                'Stroom (ster)',
                'Prąd (gwiazda)',
                'Proud (hvězda)'
            ],
            'startuptimeyd': [
                'Start-up time (Delta)',
                'Anlaufzeit (Dreieck)',
                'Tiempo de arranque (triángulo)',
                'Temps de démarrage (triangle)',
                'Tempo di avviamento (triangolo)',
                'Tempo de arranque (triângulo)',
                '启动时间（三角形）',
                'Başlatma süresi (delta)',
                'Starttijd (driehoek)',
                'Czas rozruchu (trójkąt)',
                'Doba rozběhu (trojúhelník)'
            ]
        },        
        'currentOverTime': [
            'Current Over Time',
            'Strom über Zeit',
            'Corriente en función del tiempo',
            'Courant en fonction du temps',
            'Corrente su tempo',
            'Corrente através de tempo',
            '电流与时间的关系',
            'Akıma göre zaman',
            'Stroom over tijd',
            'Prąd w czasie',
            'Proud vůči času'
        ]
    },
    'result': {
        'title': [
            'RESULT SUMMARY',
            'ZUSAMMENFASSUNG DER ERGEBNISSE',
            'RESUMEN DE LOS RESULTADOS',
            'RÉSUMÉ DES RÉSULTATS',
            'RIEPILOGO DEI RISULTATI',
            'RESUMO DOS RESULTADOS',
            '结论摘要',
            'SONUÇLARIN ÖZETİ',
            'SAMENVATTING VAN DE RESULTATEN',
            'PODSUMOWANIE WYNIKÓW',
            'SHRNUTÍ VÝSLEDKŮ'
        ],
        'exEbIIC': [
            'Please check the results of the simulation with the restrictions of the standards DIN EN60079.',
            'Bitte prüfen Sie die Simulationsergebnisse mit den Beschränkungen der Normen DIN EN60079.',
            'Compruebe los resultados de la simulación con las restricciones de las normas DIN EN60079.',
            'Vérifier les résultats de la simulation avec les restrictions des normes EN 60079.',
            'Verificare i risultati della simulazione rispetto a limiti delle norme DIN EN 60079.',
            'Compare os resultados de simulação com as restrições das normas DIN EN60079.',
            '请查看根据标准 DIN EN60079 的要求进行的仿真结果。',
            'Lütfen benzetim sonuçlarını DIN EN60079 standardının kısıtlamalarıyla kontrol ediniz.',
            'Controleer de simulatieresultaten met de beperkingen van de normen DIN EN60079.',
            'Proszę sprawdzić wyniki symulacji z ograniczeniami normy DIN EN60079.',
            'Zkontrolujte prosím výsledky simulace s omezeními danými normou DIN EN60079.'
        ],
        'loadOperationData': {
            'title': [
                'Load operation data - line operation',
                'Lastbetriebswerte - Netzbetrieb',
                'Valores de operación con carga - alimentación por red',
                'Valeurs de fonctionnement en charge - fonctionnement sur réseau',
                'Valori di esercizio sotto carico - Funzionamento da rete',
                'Valores de operação de carga - modo de rede',
                '负载运行数据 - 工频运行',
                'Yük işletim değerleri - Şebeke işletimi',
                'Lastbedrijfswaarden – Netbedrijf',
                'Wartości robocze obciążenia - praca sieciowa',
                'Provozní hodnoty zátěže - provoz s napájením ze sítě'
            ],
            'voltage': [
                '100% Voltage',
                '100% Spannung',
                '100% tensión',
                '100 % tension',
                '100% di tensione',
                '100% tensão',
                '100% 电压',
                '%100 gerilim',
                '100% spanning',
                '100% napięcia',
                'Napětí 100%'
            ],
            'specificVoltage': [
                '${x}% Voltage',
                '${x}% Spannung',
                '${x}% tensión',
                '${x}% tension',
                '${x}% di tensione',
                '${x}% tensão',
                '${x}% 电压',
                '%${x} gerilim',
                '${x}% Spanning',
                '${x}% napięcia',
                'Napětí ${x}%'
            ],
            'numberOfStartUps': [
                'Number of Start-ups',
                'Anzahl der Anläufe',
                'Número de arranques',
                'Nombre de démarrages',
                'Numero di avviamenti',
                'Número de arranques',
                '启动次数',
                'Başlatma sayısı',
                'Aantal starts',
                'Liczba rozruchów',
                'Počet rozběhů'
            ],
            'startUpTime': [
                'Start-up time',
                'Anlaufzeit',
                'Tiempo de arranque',
                'Temps de démarrage',
                'Tempo di avviamento',
                'Tempo de arranque',
                '启动时间',
                'Başlatma süresi',
                'Starttijd',
                'Czas rozruchu',
                'Doba rozběhu'
            ],
            'startUpTimeDelta': [
                'Start-up time (Delta)',
                'Anlaufzeit (Dreieck)',
                'Tiempo de arranque (triángulo)',
                'Temps de démarrage (triangle)',
                'Tempo di avviamento (triangolo)',
                'Tempo de arranque (triângulo)',
                '启动时间（三角形）',
                'Başlatma süresi (delta)',
                'Starttijd (driehoek)',
                'Czas rozruchu (trójkąt)',
                'Doba rozběhu (trojúhelník)'
            ],
            'startUpTimeStar': [
                'Start-up time (Star)',
                'Anlaufzeit (Stern)',
                'Tiempo de arranque (estrella)',
                'Temps de démarrage (étoile)',
                'Tempo di avviamento (stella)',
                'Tempo de arranque (estrela)',
                '启动时间（星形）',
                'Başlatma süresi (yıldız)',
                'Starttijd (ster)',
                'Czas rozruchu (gwiazda)',
                'Doba rozběhu (hvězda)'
            ],
            'accelerationTorqueAverage': [
                'Acceleration torque average',
                'Durchschnittliches Beschleunigungsmoment',
                'Par acelerador promedio',
                'Couple d\'accélération moyen',
                'Coppia media di accelerazione',
                'Binário de aceleração médio',
                '平均加速转矩',
                'Ortalama ivmelenme momenti',
                'Gemiddeld versnellingsmoment',
                'Średni moment przyspieszeniowy',
                'Střední hodnota momentu při zrychlování'
            ],
            'accelerationReserve': [
                'Acceleration reserve',
                'Beschleunigungsreserve',
                'Reserva de aceleración',
                'Réserve d\'accélération',
                'Riserva di accelerazione',
                'Reserva de aceleração',
                '加速储备',
                'Hızlanma yedeği',
                'Versnellingsreserve',
                'Rezerwa dynamiczna',
                'Rezerva pro zrychlení'
            ],
            'powerReserve': [
                'Power reserve',
                'Leistungsreserve',
                'Reserva de potencia',
                'Réserve de puissance',
                'Riserva di potenza',
                'Reserva de potência',
                '功率储备',
                'Güç yedeği',
                'Vermogensreserve',
                'Rezerwa mocy',
                'Výkonová rezerva'
            ],
            'ratedMotorPower': [
                'Rated motor power',
                'Motorbemessungsleistung',
                'Potencia asignada del motor',
                'Puissance assignée du moteur',
                'Potenza nominale del motore',
                'Potência de referência do motor',
                '电机额定功率',
                'Motor ölçüm gücü',
                'Nominaal motorvermogen',
                'Moc znamionowa silnika',
                'Jmenovitý výkon motoru'
            ],
            'ratedMotorSpeed': [
                'Rated motor speed',
                'Motorbemessungsdrehzahl',
                'Velocidad asignada del motor',
                'Vitesse assignée du moteur',
                'Numero di giri nominale del motore',
                'Rotações de referência do motor',
                '电机额定转速',
                'Motor ölçümü devir sayısı',
                'Nominaal motortoerental',
                'Znamionowa prędkość obrotowa silnika',
                'Jmenovité otáčky motoru'
            ],
            'ratedMotorCurrent': [
                'Rated motor current',
                'Motorbemessungsstrom',
                'Corriente asignada del motor',
                'Courant assigné du moteur',
                'Corrente nominale del motore',
                'Corrente de referência do motor',
                '电机额定电流',
                'Nominal motor akımı',
                'Nominale motorstroom',
                'Prąd znamionowy silnika',
                'Jmenovitý proud motoru'
            ],
            'loadPower': [
                'Motor operating power',
                'Motorbetriebsleistung',
                'Potencia de empleo del motor',
                'Puissance de fonctionnement du moteur',
                'Potenza di esercizio del motore',
                'Potência de operação do motor',
                '电机运行功率',
                'Motor işletim gücü',
                'Motorbedrijfsvermogen',
                'Moc robocza silnika',
                'Provozní výkon motoru'
            ],
            'loadSpeed': [
                'Motor operating speed',
                'Motorbetriebsdrehzahl',
                'Velocidad de operación del motor',
                'Vitesse de fonctionnement du moteur',
                'Velocità di esercizio del motore',
                'Rotações de operação do motor',
                '电机运行转速',
                'Motor işletim devir sayısı',
                'Motorbedrijfstoerental',
                'Prędkość robocza silnika',
                'Provozní otáčky motoru'
            ],
            'loadCurrent': [
                'Motor operating current',
                'Motorbetriebsstrom',
                'Corriente de empleo del motor',
                'Courant de fonctionnement du moteur',
                'Corrente di esercizio del motore',
                'Corrente de operação do motor',
                '电机运行电流',
                'Motor işletim akımı',
                'Motorbedrijfsstroom',
                'Prąd roboczy silnika',
                'Provozní proud motoru'
            ],
            'loadOperatingTorque': [
                'Load operating torque',
                'Lastbetriebsmoment',
                'Par de empleo de la carga',
                'Couple de fonctionnement en charge',
                'Coppia di esercizio sotto carico',
                'Binário de operação de carga',
                '负载运行转矩',
                'Yük işletim momenti',
                'Lastbedrijfsmoment',
                'Moment roboczy obciążenia',
                'Provozní moment zátěže'
            ],
            'loadOperatingSpeed': [
                'Load operating speed',
                'Lastbetriebsdrehzahl',
                'Velocidad de operación bajo carga',
                'Vitesse de fonctionnement en charge',
                'Numero di giri di esercizio sotto carico',
                'Rotações de operação de carga',
                '负载运行转速',
                'Yük işletim devir sayısı',
                'Lastbedrijfstoerental',
                'Prędkość robocza obciążenia',
                'Provozní otáčky zátěže'
            ],
            'loadTorque': [
                'Motor operating torque',
                'Motorbetriebsleistung',
                'Potencia de empleo del motor',
                'Puissance de fonctionnement du moteur',
                'Potenza di esercizio del motore',
                'Potência de operação do motor',
                '电机运行功率',
                'Motor işletim gücü',
                'Motorbedrijfsvermogen',
                'Moc robocza silnika',
                'Provozní výkon motoru'
            ],
            'ratedMotorTorque': [
                'Rated motor torque',
                'Motorbemessungsmoment',
                'Par asignado del motor',
                'Couple assigné du moteur',
                'Coppia nominale del motore',
                'Binário de referência do motor',
                '电机额定转矩',
                'Motor nominal torku',
                'Nominale motormoment',
                'Moment znamionowy silnika',
                'Jmenovitý moment motoru'
            ],
            'cold': [
                'cold',
                'kalt',
                'En frío',
                'Froid',
                'A freddo',
                'Frio',
                '冷',
                'Soğuk',
                'Koud',
                'Zimny',
                'Za studena'
            ],
            'warm': [
                'warm',
                'warm',
                'En caliente',
                'Chaud',
                'A caldo',
                'Quente',
                '热',
                'Sıcak',
                'Warm',
                'Ciepły',
                'Za tepla'
            ],
            'noStartUp': [
                'No start-up possible',
                'Anlauf nicht möglich',
                'Arranque no posible',
                'Démarrage impossible',
                'Avviamento non possibile',
                'Não é possível realizar arranque',
                '无法启动',
                'Başlatma olanaklı değil',
                'Starten niet mogelijk',
                'Rozruch nie jest możliwy',
                'Rozběh není možný'
            ]
        },
        'converterOperation': {
            'title': [
                'Load operation data - converter operation',
                'Lastbetriebswerte – Umrichterbetrieb',
                'Valores de operación con carga - alimentación por convertidor',
                'Valeurs de fonctionnement en charge - fonctionnement avec variateur',
                'Valori di esercizio sotto carico - Funzionamento con convertitore',
                'Valores de operação de carga - modo de conversor',
                '负载运行数据 - 变频运行',
                'Yük işletim değerleri - Dönüştürücü işletimi',
                'Lastbedrijfswaarden – Omvormerbedrijf',
                'Wartości robocze obciążenia - praca z przekształtnikiem',
                'Provozní hodnoty zátěže - provoz s měničem'
            ],
            'ratedPower': [
                'VSD rated power',
                'VSD Bemessungsleistung',
                'Potencia asignada VSD',
                'VSD Puissance assignée',
                'Potenza nominale del VSD',
                'Potência de referência VSD',
                'VSD 额定功率',
                'VSD nominal güç',
                'VSD Nominaal vermogen',
                'VSD Moc znamionowa',
                'Jmenovitý výkon VSD'
            ],
            'ratedTorque': [
                'VSD rated torque',
                'VSD Bemessungsdrehmoment',
                'Par asignado VSD',
                'VSD Couple assigné',
                'Coppia nominale del VSD',
                'Binário de referência do motor VSD',
                'VSD 额定转矩',
                'VSD nominal moment',
                'VSD Nominaal draaimoment',
                'VSD Znamionowy moment obrotowy',
                'Jmenovitý moment VSD'
            ],
            'ratedSpeed': [
                'VSD rated speed',
                'VSD Bemessungsdrehzahl',
                'Velocidad asignada VSD',
                'VSD Vitesse assignée',
                'Numero di giri nominale del VSD',
                'Rotações de referência VSD',
                'VSD 额定转速',
                'VSD nominal devir sayısı',
                'VSD Nominaal toerental',
                'VSD Znamionowa prędkość obrotowa',
                'Jmenovité otáčky VSD'
            ],
            'ratedCurrent': [
                'VSD rated current',
                'VSD Bemessungsstrom',
                'Corriente asignada VSD',
                'VSD Courant assigné',
                'Corrente nominale del VSD',
                'Corrente de referência VSD',
                'VSD 额定电流',
                'VSD nominal akım',
                'VSD Nominale stroom',
                'VSD Prąd znamionowy',
                'Jmenovitý proud VSD'
            ]
        },
        'motorData': {
            'frequency': [
                'Rated frequency',
                'Bemessungsfrequenz',
                'Frecuencia asignada',
                'Fréquence assignée',
                'Frequenza nominale',
                'Frequência de referência',
                '额定频率',
                'Nominal frekans',
                'Nominale frequentie',
                'Częstotliwość znamionowa',
                'Jmenovitá frekvence'
            ],
            'title': [
                'Motor data',
                'Motordaten',
                'Datos del motor',
                'Paramètres moteur',
                'Dati motore',
                'Dados do motor',
                '电机数据',
                'Motor verileri',
                'Motorgegevens',
                'Dane silnika',
                'Parametry motoru'
            ],
            'mlfb': [
                'MLFB',
                'MLFB',
                'Referencia MLFB',
                'Nº de référence',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB',
                'MLFB'
            ],
            'ratedPower': [
                'Rated power',
                'Bemessungsleistung',
                'Potencia asignada',
                'Puissance assignée',
                'Potenza nominale',
                'Potência de referência',
                '额定功率',
                'Nominal güç',
                'Nominaal vermogen',
                'Moc znamionowa',
                'Jmenovitý výkon'
            ],
            'ratedVoltage': [
                'Rated voltage',
                'Bemessungsspannung',
                'Tensión asignada',
                'Tension assignée',
                'Tensione nominale',
                'Tensão de referência',
                '额定电压',
                'Nominal gerilim',
                'Nominale spanning',
                'Napięcie znamionowe',
                'Jmenovité napětí'
            ],
            'ratedCurrent': [
                'Rated current',
                'Bemessungsstrom',
                'Corriente asignada',
                'Courant assigné',
                'Corrente nominale',
                'Corrente de referência',
                '额定电流',
                'Nominal akım',
                'Nominale stroom',
                'Prąd znamionowy',
                'Jmenovitý proud'
            ],
            'ratedTorque': [
                'Rated torque',
                'Bemessungsmoment',
                'Par asignado',
                'Couple assigné',
                'Coppia nominale',
                'Binário de referência',
                '额定转矩',
                'Nominal moment',
                'Nominaal moment',
                'Moment znamionowy',
                'Jmenovitý moment'
            ],
            'ratedSpeed': [
                'Rated speed',
                'Bemessungsdrehzahl',
                'Velocidad asignada',
                'Vitesse assignée',
                'Numero di giri nominale',
                'velocidade de referência',
                '额定转速',
                'Nominal devir sayısı',
                'Nominaal toerental',
                'Znamionowa prędkość obrotowa',
                'Jmenovité otáčky'
            ],
            'relatedLockedRotorTorque': [
                'Related locked rotor torque',
                'Bezogenes Anlaufmoment',
                'Par de arranque relacionado',
                'Constante de couple de démarrage',
                'Coppia di avviamento relativa',
                'Binário de arranque relacionado',
                '参考堵转转矩',
                'İlgili başlatma momenti',
                'Relatief startmoment',
                'Odniesiony moment rozruchu',
                'Vztažný rozběhový moment'
            ],
            'relatedBreakdownTorque': [
                'Related breakdown torque',
                'Bezogenes Kippmoment',
                'Par de vuelco relacionado',
                'Constante de couple de décrochage',
                'Coppia di inversione relativa',
                'Binário de inversão relacionado',
                '参考失步转矩',
                'İlgili devirme momenti',
                'Relatief kantelmoment',
                'Odniesiony moment utyku',
                'Vztažný moment zvratu'
            ],
            'relatedLockedRotorCurrent': [
                'Related locked rotor current',
                'Bezogener Anlaufstrom',
                'Corriente de arranque relacionada',
                'Constante de courant de démarrage',
                'Corrente di avviamento relativa',
                'Corrente de arranque relacionada',
                '参考堵转电流',
                'İlgili Başlatma akımı',
                'Relatieve startstroom',
                'Odniesiony prąd rozruchowy',
                'Vztažný rozběhový proud'
            ],
            'relatedPullUpTorque': [
                'Related pull up torque',
                'Bezogenes Sattelmoment',
                'Par mínimo de arranque relacionado',
                'Constante de couple minimal',
                'Coppia minima all\'avviamento relativa',
                'Binário dearranque relacionado',
                '参考最小转矩',
                'İlgili kaldırma momenti',
                'Relatief zadelmoment',
                'Odniesiony moment siodłowy',
                'Vztažný sedlový moment'
            ],
            'relatedPullUpSpeed': [
                'Related pull up speed',
                'Bezogene Satteldrehzahl',
                'Velocidad mínima de arranque relacionada',
                'Constante de vitesse minimale',
                'Velocità di coppia minima d\'avviamento',
                'Rotações de arranque relacionadas',
                '参考最小转速',
                'İlgili kaldırma devir sayısı',
                'Relatief zadeltoerental',
                'Odniesiona prędkość siodłowa',
                'Vztažné sedlové otáčky'
            ],
            'noLoadCurrent': [
                'No load current',
                'Leerlaufstrom',
                'Corriente en vacío',
                'Courant à vide',
                'Corrente a vuoto',
                'Corrente de marcha em vazio',
                '空载电流',
                'Boşta çalışma akımı',
                'Onbelaste stroom',
                'Prąd biegu jałowego',
                'Proud při chodu naprázdno'
            ],
            'motorTorqueOfInertia': [
                'Motor moment of inertia',
                'Läuferträgheitsmoment',
                'Momento de inercia del rotor',
                'Couple d\'inertie du rotor',
                'Momento d\'inerzia del rotore',
                'Binário de inércia do rotor',
                '电机转子转动惯量',
                'Rotor atalet momenti',
                'Rotortraagheidsmoment',
                'Moment bezwładności wirnika',
                'Moment setrvačnosti rotoru'
            ],
            'windingModes': [
                'Winding modes',
                'Wicklungsausführung',
                'Versión de devanado',
                'Exécution de l\'enroulement',
                'Esecuzione dell\'avvolgimento',
                'Modelo do enrolamento',
                '绕组规格',
                'Sargı versiyonu',
                'Wikkelingsuitvoering',
                'Wykonanie uzwojenia',
                'Provedení vinutí'
            ],
            'maxStartUpTimeWarm': [
                'Max. start-up time warm',
                'Max. Anlaufzeit warm',
                'Tiempo máx. arranque en caliente',
                'Temps de démarrage à chaud max.',
                'Tempo di avviamento max. a caldo',
                'Tempo máx. de arranque a quente',
                '最长热启动时间',
                'Azami sıcak Başlatma süresi',
                'Max. aanlooptijd warm',
                'Maks. czas rozruchu, ciepły',
                'Max. rozběhový čas za tepla'
            ],
            'maxStartUpTimeCold': [
                'Max. start-up time cold',
                'Max. Anlaufzeit kalt',
                'Tiempo máx. arranque en frío',
                'Temps de démarrage à froid max.',
                'Tempo di avviamento max. a freddo',
                'Tempo máx. de arranque a frio',
                '最长冷启动时间',
                'Azami soğuk başlatma süresi',
                'Max. starttijd koud',
                'Maks. czas rozruch, zimny',
                'Max. rozběhový čas za studena'
            ],
            'maxBlockingTimeWarm': [
                'Max blocking time warm',
                'Max. Blockierzeit warm',
                'Tiempo de bloqueo máx. en caliente',
                'Temps de blocage à chaud max.',
                'Tempo di blocco max. a caldo',
                'Tempo máx. de bloqueio a quente',
                '最长热态堵转时间',
                'Azami sıcak bloke olma süresi',
                'Max. blokkeertijd warm',
                'Maks. czas blokowania, ciepły',
                'Max. blokovací čas za tepla'
            ],
            'maxBlockingTimeCold': [
                'Max blocking time cold',
                'Max. Blockierzeit kalt',
                'Tiempo de bloqueo máx. en frío',
                'Temps de blocage à froid max.',
                'Tempo di blocco max. a freddo',
                'Tempo máx. de bloqueio a frio',
                '最长冷态堵转时间',
                'Azami soğuk bloke olma süresi',
                'Max. blokkeertijd koud',
                'Maks. czas blokowanie, zimny',
                'Max. blokovací čas za studena'
            ]
        },
        'calculateMes': [
            'Run Expert Suite',
            'Expert Suite ausführen',
            'Ejecutar Expert Suite',
            'Exécuter Expert Suite',
            'Eseguire Expert Suite',
            'Executar Expert Suite',
            '运行 Expert Suite',
            'Expert Suite yürütün',
            'Expert Suite uitvoeren',
            'Uruchom Ekspert Suite',
            'Spusťte Expert Suite'
        ]
        
    },
    'footer': {
        'contactUs': [
            'Contact us',
            'Kontakt',
            'Contact us',
            'Contact us',
            'Contact us',
            'Contact us',
            'Contact us',
            'Contact us',
            'Contact us',
            'Contact us',
            'Contact us'
        ],
        'contactUsLink': [
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/de/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map',
            'https://www.innomotics.com/hub/en/contact/map'
        ],
        'cookieNotice': [
            'Cookie Notice',
            'Cookie-Hinweise',
            'Cookie Notice',
            'Cookie Notice',
            'Cookie Notice',
            'Cookie Notice',
            'Cookie Notice',
            'Cookie Notice',
            'Cookie Notice',
            'Cookie Notice',
            'Cookie Notice'
        ],
        'cookieNoticeLink': [
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/de/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines',
            'https://www.innomotics.com/hub/en/cookie-guidelines'
        ],
        'corporateInformation': [
            'Corporate Information',
            'Unternehmensinformationen',
            'Información corporativa',
            'Informations sur l\'entreprise',
            'Informazioni aziendali',
            'Informações da empresa',
            '企业信息',
            'Şirket bilgileri',
            'Bedrijfsinformatie',
            'Informacje o firmie',
            'Informace o společnosti'
        ],
        'corporateInformationLink': [
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/de/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal',
            'https://www.innomotics.com/hub/en/general/legal'
        ],
        'digitalId': [
            'Digital ID',
            'Digitales Zertifikat',
            'ID digital',
            'ID numérique',
            'ID digitale',
            'ID digital',
            '数字 ID',
            'Sayısal tanıtıcı',
            'Digitale ID',
            'Identyfikator cyfrowy',
            'Digitální identifikace'
        ],
        'digitalIdLink': [
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/de/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id',
            'https://www.innomotics.com/hub/en/digital-id'
        ],
        'innomoticsWebsite': [
            'innomotics.com Global Website',
            'innomotics.com Globale Website',
            'Sitio web global innomotics.com',
            'le site Web international innomotics.com',
            'Sito web globale innomotics.com',
            'Página da Web global innomotics.com',
            'innomotics.com 全球网站',
            'innomotics.com küresel internet sitesi',
            'innomotics.com Globale website',
            'innomotics.com globalna strona internetowa',
            'innomotics.com Globální internetové stránky'
        ],
        'innomoticsWebsiteLink': [
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/de/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/',
            'https://www.innomotics.com/hub/en/'
        ],
        'privacyNotice': [
            'Privacy Notice',
            'Datenschutz',
            'Privacy Notice',
            'Privacy Notice',
            'Privacy Notice',
            'Privacy Notice',
            'Privacy Notice',
            'Privacy Notice',
            'Privacy Notice',
            'Privacy Notice',
            'Privacy Notice'
        ],
        'privacyNoticeLink': [
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/de/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice',
            'https://www.innomotics.com/hub/en/general/privacy-notice'
        ],
        'innomotics': [
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}',
            '© Innomotics 2023 - {date}'
        ],
        'termsOfUse': [
            'Terms of use',
            'Nutzungsbedingungen',
            'Condiciones de uso',
            'Conditions d\'utilisation',
            'Condizioni di utilizzo',
            'Condições de utilização',
            '使用条款',
            'Kullanım koşulları',
            'Gebruiksvoorwaarden',
            'Warunki użytkowania',
            'Podmínky pro používání'
        ],
        'termsOfUseLink': [
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/de/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use',
            'https://www.innomotics.com/hub/en/general/terms-of-use'
        ]
    },
    'tooltips': {
        'tagbar': [
            'The changes made in the Expert Suite can be reset one by one (by clicking on the cross next to the change) or all at once (by clicking on the "Reset values" button). </br></br> By clicking on the "Create document" button, the documentation is created as a ".pdf" document.',
            'Die in der Expert Suite vorgenommenen Änderungen können einzeln (mit einem Klick auf das Kreuz neben der Änderung) oder alle auf einmal (mit einem Klick auf die Taste „Auswahl zurücksetzen“) zurückgesetzt werden.</br></br> Mir einem Klick auf die Taste „Dokument erstellen“ wird die Dokumentation als „.pdf“ Dokument erstellt.',
            'Los cambios realizados en el Expert Suite se pueden restablecer uno por uno (haciendo clic en la cruz junto al cambio) o todos a la vez (haciendo clic en el botón "Anular selección").</br></br> Con un clic en el botón "Crear documento\', la documentación se crea como documento ".pdf".',
            'Les modifications effectuées dans le Expert Suite peuvent être réinitialisées individuellement (en cliquant sur la croix à côté de la modification) ou toutes en même temps (en cliquant sur la touche "Réinitialiser la sélection").</br></br> Un clic sur la touche "Créer un document" permet de créer la documentation au format ".pdf".',
            'Le modifiche apportate in Expert Suite possono essere azzerate singolarmente (facendo clic sulla croce accanto alla modifica) o congiuntamente (facendo clic sul pulsante "Annullare la selezione").</br></br> Facendo clic sul pulsante "Creare documento" viene creata la documentazione in formato ".pdf".',
            'As alterações realizadas na Expert Suite podem ser anuladas individualmente (com um clique na cruz ao lado da alteração) ou todas de uma vez (com um clique na tecla "Repor seleção".</br></br> Clicando na tecla "Criar documento" a documentação é convertida em documento "pdf".',
            '在 Expert Suite 中可分别对每项进行单独更改（点击更改项旁的“X” 按键）或进行全部一键重置（点击“重置选择”按键）。</br></br> 点击“创建文档”按键，生成“.pdf” 文档。',
            'Expert Suite\'te gerçekleştirilen değişiklikler (değişikliğin yanındaki çarpı tıklanarak) teker teker veya ("Seçimi sıfırla" tuşu tıklanarak) hepsi birden sıfırlanabilir.</br></br> "Doküman oluştur" tuşu tıklanarak, dokümantasyon ".pdf" belgesi olarak oluşturulur.',
            'De in de Expert Suite aangebrachte wijzigingen kunnen individueel (met een klik op het kruis naast de wijziging) of alle ineens (met een klik op de toets „Selectie resetten“) worden teruggezet.</br></br> Met een klik op de toets “Document aanmaken” wordt de documentatie als “pdf”-document aangemaakt.',
            'Zmiany dokonane w Expert Suite można zresetować pojedynczo (klikając na krzyżyk obok zmiany) lub wszystkie na raz (klikając przycisk „Zresetuj wybór”).</br></br> Po kliknięciu przycisku „Utwórz dokument” zostanie sporządzona dokumentacja w postaci pliku „.pdf”.',
            'Změny provedené v Expert Suite lze resetovat jednotlivě (kliknutím na křížek vedle změny) nebo všechny najednou (kliknutím na tlačítko „Obnovit původni výběr“).</br></br> Po kliknutí na tlačítko „Vytvořeni dokumentu“ se dokumentace vytvoří jako dokument ".pdf"'
        ],
        'startingVoltage': [
            'DOL start-up for the 1LEx standard motors can be simulated in the range of 80-100% of the rated voltage. </br> Y/D start-up can only be simulated at the rated voltage. </br></br> DOL start-up for the 1MBx explosion proof motors can be simulated in the range of 90-100% of the rated voltage. </br> Y/D start-up can only be simulated at the rated voltage.',
            'DOL Anlauf bei den Standardmotoren 1LEx kann im Bereich 80-100% der Bemessungsspannung simuliert werden. </br> Y/D Anlauf kann nur bei der Bemessungsspannung simuliert werden. </br></br> DOL Anlauf bei den Explosionsgeschützten Motoren 1MBx kann im Bereich 90-100% der Bemessungsspannung simuliert werden. </br> Y/D Anlauf kann nur bei der Bemessungsspannung simuliert werden.',
            'En los motores estándar 1LEx, el arranque DOL puede simularse en el rango de 80-100 % de la tensión nominal.</br> El arranque Y/D solo se puede simular con la tensión asignada.</br></br>En los motores a prueba de explosiones, el arranque DOL se puede simular en el rango de 90-100 % de la tensión asignada.</br>El arranque Y/D solo se puede simular con la tensión asignada.',
            'Le démarrage DOL pour les moteurs standards 1LEx peut être simulé dans la plage 80-100 % de la tension assignée.</br>Le démarrage Y/D ne peut être simulé qu\'avec la tension assignée.</br></br>Le démarrage DOL pour les moteurs antidéflagrants 1MBx peut être simulé dans la plage 90-100 % de la tension assignée.</br>Le démarrage Y/D ne peut être simulé qu\'avec la tension assignée.',
            'L\'avviamento DOL nei motori standard 1LEx può essere simulato nel campo 80-100% della tensione nominale. </br>L\'avviamento Y/D può essere simulato solo con la tensione nominale.</br></br>L\'avviamento DOL nei motori antideflagranti 1MBx può essere simulato nel campo 90-100% della tensione nominale.</br>L\'avviamento Y/D può essere simulato solo con la tensione nominale.',
            'O arranque DOL em motores padrão 1LEx pode ser simulado na gama de 80-100% da tensão de referência.</br>O arranque Y/D só pode ser simulado com a tensão de referência.</br></br>O arranque DOL em motores com proteção contra explosão 1MBx pode ser simulado na gama 90-100% da tensão de referência.</br>O arranque Y/D só pode ser simulado com a tensão de referência.',
            '1LEx 标准电机的 DOL 起动可以在额定电压的80-100%范围内模拟。</br> Y/D 起动只能在额定电压时模拟。</br></br>1MBx 防爆电机的 DOL 起动可以在额定电压的90-100%范围内模拟  。</br> Y/D 起动只能在额定电压时模拟。',
            '1LEx standart motorlarındaki DOL başlatması, nominal gerilimin %80-100\'ü aralığında simüle edilebilir.</br>Y/D başlatması ancak nominal gerilimde simüle edilebilir.</br></br>Patlama korumalı 1MBx motorlarındaki DOL başlatması, nominal gerilimin %90-100\'ü aralığında simüle edilebilir.</br> Y/D başlatması ancak nominal gerilimde simüle edilebilir.',
            'DOL start bij de standaardmotoren 1LEx kan in het bereik 80-100% van de nominale spanning worden gesimuleerd.</br> Y/D Start kan alleen bij de nominale spanning worden gesimuleerd. </br></br>DOL start bij de explosieveilige motoren 1MBx kan in het bereik 90-100% van de nominale spanning worden gesimuleerd.</br> Y/D Start kan alleen bij de nominale spanning worden gesimuleerd.',
            'Rozruch DOL w przypadku silników standardowych 1LEx można symulować w zakresie 80-100% napięcia znamionowego.</br>Rozruch Y/D można symulować przy napięciu znamionowym.</br></br>Rozruch DOL w przypadku silników z zabezpieczeniem przeciwwybuchowym 1MBx można symulować w zakresie 90-100% napięcia znamionowego.</br> Rozruch Y/D można symulować przy napięciu znamionowym.',
            'Rozběh DOL u standardních motorů 1LEx lze simulovat v rozsahu 80-100 % jmenovitého napětí. </br>Rozběh Y/D lze simulovat pouze při jmenovitém napětí.</br></br>Rozběh DOL pro motory 1MBx do výbušného prostředí lze simulovat v rozsahu 90-100 % jmenovitého napětí.</br>Rozběh Y/D lze simulovat pouze při jmenovitém napětí.'
        ],
        'startingType': [
            'Motors that have 6 connections in the junction box, e.g. with the voltage code "3-4", can also be simulated in Y/D circuit.</br></br> The starting current is reduced with the "Y/D" start. This starting method leads to a longer start-up time and a reduced starting torque of the motor. With this start-up method, the motor can no longer start under full load. Please reduce the operating torque if necessary.',
            'Motoren, die 6 Anschlüsse im Anschlusskasten haben z.B. mit der Spannungskennziffer „3-4“, können auch in Y/D-Schaltung simuliert werden.</br></br> Bei dem „Y/D“ Anlauf wird der Anlaufstrom reduziert. Diese Anlaufmethode führt dazu, dass die Anlaufzeit länger wird und das Anlaufmoment des Motors reduziert wird. Bei dieser Anlaufmethode kann der Motor nicht mehr unter voller Last anlaufen. Bitte eventuell das Betriebsmoment reduzieren.',
            'Los motores que tienen 6 conexiones en la caja de conexión, por ejemplo, con el código de tensión "3-4", también se pueden simular en circuitos Y/D.</br></br> Con el arranque "Y/D", la corriente de arranque se reduce. Este método de arranque prolonga el tiempo de arranque y reduce el par de arranque del motor. Con este método de arranque, el motor ya no puede arrancar a plena carga. Por favor, reduzca el par de empleo si es necesario.',
            'Les moteurs dotés de 6 connexions dans la boîte à bornes, p. ex. avec le chiffre caractéristique de tension "3-4", peuvent aussi être soumis à une simulation de la commutation Y/D.</br></br> En cas de démarrage Y/D, le courant de démarrage est réduit. Cette méthode de démarrage a pour effet d\'allonger le temps de démarrage et de réduire le couple de démarrage du moteur. Avec cette méthode de démarrage, le moteur ne peut plus démarrer en pleine charge. Réduire le couple de fonctionnement, le cas échéant.',
            'I motori con 6 contatti nella cassetta di connessione, ad es. con il codice di tensione "3-4", possono essere simulati anche nel collegamento Y/D.</br></br> Con l\'avviamento "Y/D", la corrente di avviamento viene ridotta. Questo metodo di avviamento comporta un allungamento dei tempi di avviamento e una riduzione della coppia di avviamento del motore. Con questo metodo di avviamento, il motore non può più avviarsi a pieno carico. Ridurre eventualmente la coppia di esercizio.',
            'Os motores que possuem 6 ligações na caixa de ligações, por ex., com um indicador de tensão "3-4" também podem ser simulados no circuito Y/D.</br></br> Durante o arranque "Y/D" é reduzida a corrente de arranque. Este método de arranque implica que o tempo de arranque seja maior e que o torque de arranque do motor seja reduzido. Com este método de arranque o motor já não pode arrancar com a carga total. Se necessário, reduzir o torque de operação.',
            '接线盒中有 6 个接线柱的电机，例如带有电压标识 “3-4” 的接头，可以在 Y/D 电路中进行模拟。</br></br> 在进行“Y/D”起动时，起动电流减小 。这种起动方法会导致起动时间延长，电机的起动扭矩减小。采用这种起动方法时，起动电机无法满载起动。如有必要，请降低驱动扭矩。',
            'Bağlantı kutusunda 6 bağlantısı olan motorlar, örn. gerilim referans çizgisi "3-4" olanlar, Y/D çalıştırmasında da simüle edilebilir.</br></br> "Y/D" başlatmasında başlatma akımı azaltılır. Bu başlatma yöntemi, başlatma süresinin uzamasına ve motoru başlatma momentinin azaltılmasına neden olur. Bu başlatma yönteminde motor artık tam dolu yük altında başlayamaz. Lütfen gerekirse işletme momentini azaltın.',
            'Motoren die 6 aansluitingen in de aansluitkast hebben, bijv. met spanningskenwaarde „3-4“ kunnen ook in Y/D-schakeling worden gesimuleerd.</br></br> Bij de „Y/D“-start wordt de startstroom gereduceerd. Deze aanloopmethode leidt ertoe dat de starttijd langer wordt en het startmoment van de motor wordt gereduceerd. Bij deze startmethode kan de motor niet meer onder volle last starten. Reduceer indien nodig het bedrijfsmoment.',
            'Silniki, które posiadają 6 przyłączy w skrzynce przyłączowej, np. z wyróżnikiem napięcia „3-4”, można symulować również w układzie Y/D.</br></br> W przypadku rozruchu „Y/D” prąd rozruchu jest zmniejszany. Ta metoda rozruchu prowadzi do tego, że czas rozruchu wydłuża się i następuje redukcja momentu rozruchowego silnika. W przypadku tej metody rozruchu silnik niemożliwy jest już rozruch silnika z pełnym obciążeniem. Ewentualnie należy zredukować moment roboczy.',
            'Motory, které mají ve svorkovnici 6 přípojek, např. s kódovým číslem napětí „3-4“, lze rovněž simulovat v obvodu Y/D. </br></br>Při rozběhu „Y/D“ se snižuje rozběhový proud. Tento způsob rozběhu má za následek prodloužení doby rozběhu a snížení momentu motoru při rozběhu. Při tomto způsobu rozběhu se motor nerozběhne, pokud je plně zatížen. Případně snižte provozní moment.'
        ],
        'tolerance': [
            'If the "With tolerance" option is selected, as a safety, the torque curve of the motor is additionally reduced by 10% and the tightening torque and pull-up torque by 15%.',
            'Wenn die Option „Mit Toleranz“ ausgewählt ist, wird bei der Drehmomentkurve des Motors als Sicherheit zusätzlich das Kippmoment um 10% und das Anzugsmoment und Sattelmoment um 15% reduziert. ',
            'Si está seleccionada la opción „Con tolerancia“, en la curva de par del motor se reduce además, a modo de seguridad, el par máximo en un 10 % y el par de arranque y el par mínimo de arranque en un 15 %. ',
            'Lorsque l\'option "Avec tolérance" est sélectionnée, une sécurité supplémentaire est appliquée à la courbe de couple du moteur par la réduction de 10 % du couple de décrochage et de 15 % du couple de serrage et du couple minimal.',
            'Se si seleziona l\'opzione "Con tolleranza", alla curva di coppia del motore, la coppia di stallo viene inoltre ridotta per sicurezza del 10% e la coppia minima all\'avviamento del 15%.',
            'Se estiver selecionada a opção "Com tolerância", serão reduzidos na curva de torque do motor, como segurança, Adicionalmente o momento de derrube em 10% e o torque de aperto e torque de arranque em 15%.',
            '如果选择“含公差”选项，出于安全考虑，额外将电机扭矩曲线的失步转矩降低 10%，将起动力矩和底座扭矩降低 15%。',
            'Toleranslı seçeneği seçildiğinde, motorun tork eğrisinde güvenlik için ayrıca devirme momenti %10 ve sıkma torku ve eyer momenti de %15 azaltılır.',
            'Als de optie „Met tolerantie“ is geselecteerd, wordt bij de draaimomentcurve van de motor als veiligheid bijkomend het kantelmoment met 10% en het acceleratiemoment en zadelmoment met 15% gereduceerd.',
            'Jeżeli wybrana jest opcja „Z tolerancją”, w przypadku krzywej momentu obrotowego silnika jako zabezpieczenie dodatkowo moment wywracający redukowany jest o 10%, a moment dokręcania i moment podciągający o 15%.',
            'Pokud je zvolena možnost „S tolerancí“, bude u křivky krouticího momentu motoru navíc snížen moment zvratu o 10 % a tahový a sedlový moment o 15 %.'
        ],
        'numberOfStartUps': [
            'According to the valid standard DIN EN 60034-12 (2017-12-01) point 9.3, each electric motor must be designed for two starts from the cold state and one start from the warm state. </br></br>The customer-specific number of attempts can also be checked.</br> To do this, please deselect the default setting and make individual entries.',
            'Gemäß der gültigen Norm DIN EN 60034-12 (2017-12-01) Punkt 9.3, muss jeder elektrische Motor für zwei Anläufe aus dem kalten Zustand und einen Anlauf aus dem warmen Zustand ausgelegt sein. </br></br>Geprüft werden kann auch die kundenspezifische Anzahl der Anläufe.</br> Dazu bitte die Standard Einstellung abwählen und eigene Eingaben vornehmen.',
            'De acuerdo con la norma vigente EN 60034-12 (2017-12-01) punto 9.3, todo motor eléctrico debe estar dimensionados para dos arranques en frío y un arranque en caliente.sein. </br></br>También se puede comprobar el número arranques específico del cliente. Para ello, desmarque el ajuste "Estándar" e introduzca sus propios ajustes.',
            'Selon la norme applicable EN 60034-12 (2017-12-01) point 9.3, chaque moteur électrique doit être conçu pour deux démarrages à froid et un démarrage à chaud. </br></br>Le nombre de démarrages spécifiques au client peut également être vérifié. </br> Pour ce faire, désélectionner le réglage standard et renseigner des données personnalisées.',
            'Secondo la norma vigente DIN EN 60034-12 (2017-12-01), punto 9.3, ogni motore elettrico deve essere progettato per due avviamenti a freddo e uno a caldo. </br></br> È inoltre possibile controllare il numero di avviamenti specifico del cliente.</br> A tal fine, deselezionare l\'impostazione predefinita e inserire le proprie impostazioni.',
            'Conforme a norma em vigor DIN EN 60034-12 (2017-12-01) ponto 9.3, todos os motores elétricos têm de estar preparados para dois arranque a partir do frio e um arranque a partir do quente. </br></br>O número de arranques específico do cliente também pode ser testado.</br>Para tal, desmarcar a configuração padrão e fazer as próprias definições.',
            '根据现行 DIN EN 60034-12 (2017-12-01) 标准第 9.3 项规定，每台电机的设计必须满足冷机两次起动和暖机一次起动。 </br></br>还可以检测客户自定义起动次数。为此，请取消选择默认设置并自行按需输入。',
            'Geçerli DIN EN 60034-12 (2017-12-01) standardı madde 9.3 uyarınca her elektrik motoru soğuk durumdan iki başlatma ve sıcak durumdan bir başlatma için tasarlanmış olmalıdır. </br></br>Başlatmaların müşteriye özel sayısı da kontrol edilebilir.</br>Bunun için lütfen standart ayardaki seçimi kaldırın ve kendi girişlerinizi yapın.',
            'Volgens de geldende norm DIN EN 60034-12 (2017-12-01) punt 9.3 moet iedere elektrische motor voor twee starts vanuit de koude toestand en een start vanuit de warme toestand ontworpen zijn. </br></br>Ook het voor de klant specifieke aantal starts kan worden gecontroleerd.</br>Selecteer daartoe de standaardinstelling en geef eigen instellingen in.',
            'Zgodnie z obowiązującą normą DIN EN 60034-12 (2017-12-01) punkt 9.3 każdy silnik elektryczny musi być przystosowany do dwóch rozruchów ze stanu zimnego i jednego rozruchu ze stanu ciepłego. </br></br>Możliwe jest sprawdzenie również liczby rozruchów dostosowanej do potrzeb klienta.</br>W tym celu należy anulować wybór nastawy standardowej i wprowadzić własne wartości.',
            'Podle platné normy DIN EN 60034-12 (1. 12. 2017), bod 9.3, musí být každý elektromotor navržen pro dva rozběhy ze studeného stavu a jeden rozběh z teplého stavu. </br></br>Lze také ověřit počet spuštění pro konkrétního zákazníka.</br>Za tímto účelem zrušte výběr výchozího nastavení a zadejte vlastní hodnoty.'
        ],
        'loadCharacteristics': [
            'The user can choose from the following load characteristics:</br></br>a) "square without breakaway torque" M=n²; M₀=0 Nm (fans, centrifugal pumps, centrifuges)</br>b) "square with breakaway torque" M=n²; M₀=0 Nm (fans, centrifugal pumps, centrifuges with a counter-torque at "0" revolutions)</br>c) "Constant" M = constant (elevators, cranes, piston pumps; assembly lines)</br>d) "Linear" M=n (calender)</br>e) "Unloaded" M=0 (unloaded)</br>f) "User-defined" n₀=0 / M₀=...; n₁₋₃=... / M₁₋₃=...; n₄=nsyn, M₄=MN (Customer-specific application)',
            'Dem Anwender stehen folgende Lastkennlinien zur Auswahl:</br></br>a) „Quadratisch ohne osbrechmoment“ M=n²; M₀=0 Nm (Lüfter, Kreiselpumpen, Zentrifugen)</br> b) „Quadratisch mit Losbrechmoment“ M=n²; M₀>0 Nm (Lüfter , Kreiselpumpen, Zentrifugen mit einem Gegenmoment  bei „0“ Umdrehungen)</br>c) „Konstant“ M=konstant (Aufzüge, Kräne, Kolbenpumpen; Fließbänder)</br>d) „Linear“ M=n (Kalander)</br>e) „Unbelastet“ M=0 (unbelastet)</br>f) „Benutzerdefiniert“ n₀=0 / M₀=…; n₁₋₃=… / M₁₋₃=…; n₄=nsyn, M₄=MN (kundenspezifische Applikation)',
            'El usuario puede elegir entre las siguientes características de carga:</br></br>a) "Cuadrática sin par de despegue" M=n²; M₀=0 Nm (ventiladores, bombas centrífugas, centrífugas)</br>b) "Cuadrática con par de despegue" M=n²; M₀>0 Nm (ventiladores, bombas centrífugas, centrífugas con un par de reacción a "0" vueltas)</br>c) M „constante“ M=constante (ascensores, grúas, bombas de pistón; cintas transportadoras)</br>d) M „lineal“ M=n (calandra)</br>e) „Sin carga“ M=0 (sin carga)</br>f) „Personalizada“ n₀=0 / M₀=…; n₁₋₃=… / M₁₋₃=…; n₄=nsyn, M₄=MN (aplicación del cliente)',
            'Les caractéristiques de charge suivantes peuvent être sélectionnées par l\'utilisateur:</br></br>a) "Carré sans couple de décollage" M=n² ; M₀=0 Nm (ventilateurs, pompes centrifuges, centrifugeuses)</br>b) "Carré avec couple de décollage" M=n² ; M₀>0 Nm (ventilateurs, pompes centrifuges, centrifugeuses avec un couple résistant à "0" tours)</br>c) "Constant" M=constant (pour ascenseurs, grues, pompes à piston, bandes roulantes)</br>d) "Linéaire" M=n (calandre)</br>e) "Sans charge" M=0 (sans charge)</br>f) "Personnalisé" n₀=0 / M₀=… ; n₁₋₃=… / M₁₋₃=… ; n₄=nsyn, M₄=MN (application spécifique au client)',
            'L\'utente può scegliere tra le seguenti caratteristiche di carico:</br></br>a) "Quadratica senza coppia di spunto" M=n²; M₀=0 Nm (ventilatori, pompe centrifughe, centrifughe)</br>b) "Quadratica con coppia di spunto" M=n²; M₀>0 Nm (ventilatori, pompe centrifughe, centrifughe) con una coppia di spunto a "0" giri)</br>c) "Costante" M=costante (ascensori, gru, pompe a pistoni; nastri trasportatori continui)</br>d) "Lineare" M=n (calandre)</br>e) "Senza carico" M=0 (scarico)</br>f) "Definito dall\'utente" n₀=0 / M₀=…; n₁₋₃=… / M₁₋₃=…; n₄=nsyn, M₄=MN (applicazione specifica del cliente)',
            'O utilizador dispões das seguintes curvas caraterísticas de carga para seleção:</br></br>a) "Quadrado sem torque inicial" M=n²; M₀=0 Nm (ventilador, bombas rotativas, centrifugadoras)</br>b) "Quadrado com torque inicial" M=n²; M₀>0 Nm (ventilador, bombas rotativas, centrifugadoras com um contra-momento às "0" rotações)</br>c) "Constante" M=constante (elevadores, gruas, bombas de êmbolo; linhas de montagem)</br>d) "Linear" M=n (calandra)</br>e) "Sem carga" M=0 (sem carga)</br>f) "Personalizado" n₀=0 / M₀=…; n₁₋₃=… / M₁₋₃=…; n₄=nsyn, M₄=MN (aplicação específica do cliente)',
            '用户可以选择以下负载特性：</br></br>a) “无起动转矩的二次幂”M=n²；M₀=0 Nm（风扇、离心泵、离心分离机）</br>b) “含起动转矩的二次幂”M=n²；M₀>0 Nm（风扇、离心泵、离心分离机，带有“0”转数时的平衡力矩）</br>c) “常数”M=常数（升降机、起重机、活塞泵、传送带）</br>d) “线性”M=n（压延机）</br>e) “空载”M=0（空载）</br>f) “用户自定义”n₀=0 / M₀=…；n₁₋₃=… / M₁₋₃=…；n₄=nsyn，M₄=MN （客户自定义应用）',
            'Kullanıcı, aşağıdaki yük referans çizgileri arasından seçim yapabilir:</br></br>a) "Ayrılma momentsiz kare" M=n²; M₀=0 Nm (fan, santrifüj pompaları, santrifüjler)</br>b) "Ayrılma momentli kare" M=n²; M₀>0 Nm (fan, santrifüj pompaları, santrifüjler "0" turda bir karşı torklu)</br> c) "Sabit" M=sabit (Asansörler, vinçler, piston pompaları; onveyörler)</br> d) "Doğrusal" M=n (Perdah)</br>e) "Yüksüz" M=0 (yüksüz)</br>f) "Kullanıcı tanımlı" n₀=0 / M₀=…; n₁₋₃=… / M₁₋₃=…; n₄=nsyn, M₄=MN (müşteriye özel uygulama)',
            'De gebruiker kan kiezen tussen volgende lastkenlijnen:</br></br>a) „Kwadraat zonder losbreekmoment“ M=n²; M₀=0 Nm (Ventilator, centrifugale pompen, centrifuges)</br>b) „Kwadraat met losbreekmoment“ M=n²; M₀>0 Nm (Ventilator, centrifugale pompen, centrifuges met een contramoment bij „0“ omwentelingen)</br>c) „Constant“ M=constant (liften, kranen, plunjerpompen, vloeibanden)</br>d) „Lineair“ M=n (Kalander)</br>e) „Onbelast“ M=0 (onbelast)</br>f) „Gebruikergedefinieerd“ n₀=0 / M₀=…; n₁₋₃=… / M₁₋₃=…; n₄=nsyn, M₄=MN (specifieke applicatie van de klant)',
            'Użytkownik ma do wyboru następujące charakterystyki obciążenia:</br></br>a) „kwadratowa bez momentu zrywającego” M=n²; M₀=0 Nm (wentylatory, pompy odśrodkowe, wirówki)</br>b) „kwadratowa z momentem zrywającym” M=n²; M₀>0 Nm (wentylatory, pompy odśrodkowe, wirówki z momentem oporowym przy „0” obrotów)</br>c) „stała” M=stała (windy, dźwigi, pompy tłokowe; taśmy produkcyjne</br>d) „liniowa” M=n (kalandry)</br>e) „nieobciążona” M=0 (bez obciążenia)</br>f) „zdefiniowana przez użytkownika” n₀=0 / M₀=…; n₁₋₃=… / M₁₋₃=…; n₄=nsyn, M₄=MN (aplikacja dostosowana do potrzeb klienta)',
            'Uživatel si může vybrat z následujících charakteristik zatížení:</br></br>a) „kvadratická bez uvolňovacího momentu“ M=n²; M₀=0 Nm (ventilátory, odstředivá čerpadla, odstředivky)</br>b) „kvadratická s uvolňovacím momentem“ M=n²; M₀>0 Nm (ventilátory, odstředivá čerpadla, odstředivky s protiběžným momentem při otáčkách „0“)</br>c) „Konstantní“ M=konstantní (výtahy, jeřáby, pístová čerpadla; dopravníkové pásy)</br>d) „Lineární“ M=n (kalandry)</br>e) „Bez zatížení“ M=0 (bez zatížení)</br>f) „Uživatelsky definovaná“ n₀=0 / M₀=...; n₁₋₃=... / M₁₋₃=...; n₄=nsyn, M₄=MN (vlastní aplikace)'
        ],
        'loadCoupling': [
            'A simulation for direct coupling or coupling with gearbox / belt is possible.</br></br>For the coupling type "With gearbox or belt", the total possible load moment of inertia is reduced by the moment of inertia of the gearbox.</br>With a ratio factor "n2" > "n1", the maximum load moment of inertia is reduced.</br>With a reduction factor "n2" < "n1\', the maximum load moment of inertia is increased.',
            'Möglich ist eine Simulation für Direktkupplung oder Kupplung mit Getriebe / Riemen.</br></br>Bei der Kupplungsart „Mit Getriebe oder Riemen“ wird sich das gesamtmögliche Lastträgheitsmoment um das Trägheitsmoment des Getriebes verringern.</br>Bei einer Übersetzung „n2“ > „n1“ wird das maximale Lastträgheitsmoment reduziert.</br>Bei einer Untersetzung „n2“ < „n1“ wird das maximale Lastträgheitsmoment steigen.',
            'Es posible una simulación para el acoplamiento directo o el acoplamiento con reductor o correa.</br></br>Con el tipo de acoplamiento „Con reductor o correa“ el momento de inercia de carga total posible se reducirá en el momento de inercia del reductor.</br>Con una relación „n2“ > „n1“ se reducirá el momento de inercia de carga máximo.</br>Con una reducción „n2“ < „n1“ aumentará el momento de inercia de carga máximo.',
            'Une simulation est possible pour le couplage direct ou le couplage avec réducteur / courroie.</br></br>En couplage "Avec réducteur ou courroie", tout le couple possible d\'inertie de la charge sera réduit d\'autant que le couple d\'inertie du réducteur.</br>Pour un rapport de transmission "n2" > "n1", le couple maximal d\'inertie de la charge est réduit.</br>Pour un rapport de réduction "n2" < "n1", le couple maximal d\'inertie de la charge augmente.',
            'È possibile una simulazione per l\'accoppiamento diretto o per l\'accoppiamento con cambio / cinghia.</br></br>Con il tipo di accoppiamento "Con ingranaggio o cinghia", il momento di inerzia totale possibile del carico si riduce del momento di inerzia del riduttore.</br>Con un rapporto di trasmissione "n2" > "n1" si riduce il momento di inerzia massimo del carico.</br>Con una riduzione "n2" < "n1" il momento d\'inerzia massimo del carico aumenterà.',
            'Possibilidade de simulação para acoplamento direto ou acoplamento com redutor / correia.</br></br>No tipo de acoplamento "Com redutor ou correia" será reduzido o momento de carga de total possível pelo momento de inércia do redutor.</br>Numa transmissão "n2" > "n1" será reduzido o momento máxima de carga de inércia.</br>Numa transmissão "n2" < "n1" será aumentado o momento máximo de carga de inércia.',
            '可以模拟直接耦合或通过变速器/传动带的耦合。</br></br>如果采用“通过变速器或传动带”的耦合方式，可能的总负载惯性矩会降低变速器的惯性矩的量。</br>如果传动比“n2”>“n1”，则最大负载惯性矩降低。</br>如果传动比“n2”<“n1”，则最大负载惯性矩升高。',
            'Doğrudan bağlama veya redüktörlerle / kayışlarla bağlama için bir simülasyon mümkündür.</br></br>"Redüktörlerle veya kayışla" bağlama türünde, olabilecek tüm yük eylemsizlik  momenti, redüktörün eylemsizlik momenti kadar azaltılır.</br>"n2" > "n1" aktarmasında maksimum yük eylemsizlik momenti azaltılır.</br>"n2" > "n1" aşağı aktarmasında maksimum yük eylemsizlik momenti artırılır.',
            'Een simulatie voor directe koppeling of koppeling met transmissie / riemen is mogelijk.</br></br>Bij het koppelingstype „Met transmissie of riemen“ zal het totaal mogelijke lasttraagheidsmoment met het traagheidsmoment van de transmissie verminderen.</br>Bij een overbrenging „n2“ > „n1“ wordt het maximale lasttraagheidsmoment gereduceerd.</br>Bij een overbrenging „n2“< „n1“ zal het maximale lasttraagheidsmoment stijgen.',
            'Możliwa jest symulacja dla sprzęgła bezpośredniego lub sprzęgła z przekładnią/pasem.</br></br>W przypadku rodzaju sprzęgła „z przekładnią lub pasem” całkowity możliwy moment bezwładności obciążenia zmniejszy się o moment bezwładności przekładni.</br>W przypadku przełożenia multiplikującego „n2” > „n1” maksymalny moment bezwładności obciążenia zmniejszy się.</br>W przypadku przełożenia redukującego „n2” < „n1” maksymalny moment bezwładności obciążenia wzrośnie.',
            'Je možná simulace pro přímou spojku nebo spojku s převodem / řemenem.</br></br>U spoje typu „S převodem nebo řemenem" se celkový možný moment setrvačnosti zátěže sníží o moment setrvačnosti převodu.</br>Při převodovém poměru „n2“ > "n1" se sníží maximální moment setrvačnosti zátěže.</br>Při snížení „n2“ < "n1" se zvýší maximální moment setrvačnosti zátěže.'
        ],
        'diagram': [
            'The "Scale" button can be used to toggle between "Absolute values" and "Related values".</br></br>The displayed trends can be enlarged with "Click and drag". The enlarged area can be moved horizontally after clicking "Activate move". Clicking "Activate magnification" enables magnification again.</br>To reset the magnification, press the "Reset magnification" button.</br></br>The displayed trends can be deactivated or reactivated in the lower part (legend). Disabled trends do not appear in the documentation.',
            'Mit der Taste „Skalierung“ kann zwischen „Absolutwerte“ und „Bezogene Werte“ umgeschaltet werden.</br></br>Die angezeigten Kurven können mit „Klicken und Ziehen“ vergrößert werden. Der vergrößerter Bereich kann horizontal verschoben werden, nachdem die Taste „Verschieben aktivieren“ betätigt wurde. Vergrößerung wird wieder möglich wenn die Taste „Vergrößerung aktivieren“ gedrückt wird. </br>Um die Vergrößerung zurückzusetzen, bitte die Taste „Vergrößerung zurücksetzen“ drücken.</br></br>Die angezeigten Kurven können im unteren Teil (Legende) deaktiviert oder erneut aktiviert werden. Deaktivierte Kurven werden in der Dokumentation nicht angezeigt.',
            'Con el botón "Escala" se puede cambiar entre "Valores absolutos“ y „Valores relativos“.</br></br>Las curvas mostradas se pueden ampliar con "Hacer clic y arrastrar". El área ampliada se puede mover horizontalmente después de presionar el botón "Activar desplazamiento". Se puede volver a ampliar una vez presinoado el botón "Activar ampliación". </br>Para restablecer la ampliación, presione el botón "Restablecer ampliación".</br></br>Las curvas mostradas se puede desactivar o volver a activar en la parte inferior (leyenda). Las curvas desactivadas no se muestran en la documentación.',
            'La touche "Facteur d\'échelle" permet de commuter entre "Valeurs absolues" et "Valeurs de référence".</br></br>Les courbes affichées peuvent être agrandies avec un "cliquer-glisser". La plage agrandie peut être décalée horizontalement après avoir activé la touche "Activer le décalage". L\'agrandissement est à nouveau possible après avoir appuyé sur la touche "Activer l\'agrandissement". </br> Pour réinitialiser l\'agrandissement, appuyer sur la touche "Réinitialiser l\'agrandissement".</br></br>Les courbes affichées peuvent être désactivées ou réactivées dans la partie inférieure (légende). Les courbes désactivées ne sont pas affichées dans la documentation.',
            'Con il tasto "Scalatura" si può passare da "Valori assoluti" a "Valori relativi".</br></br>Le curve visualizzate possono essere ingrandite con "clic e trascina". L\'area ingrandita può essere spostata orizzontalmente dopo aver premuto il tasto "Attiva spostamento".</br>L\'ingrandimento diventa nuovamente possibile quando si preme il tasto "Attiva ingrandimento". Per ripristinare l\'ingrandimento, premere il tasto "Ripristina ingrandimento".</br></br>Le curve visualizzate possono essere disattivate o riattivate nella parte inferiore (legenda). Le curve disattivate non vengono mostrate nella documentazione.',
            'A tecla "Escala" permite alternar entre "Valore absolutos" e "Valores relativos".</br></br>As curvas exibidas podem ser aumentadas com "Clicar e arrastar". A área aumentada pode ser deslocada horizontalmente, depois de ativar a tecla "Ativar deslocação". Pode fazer o zoom depois de carregar na tecla  "Ativar zoom". </br>Para anular o zoom, carregue na tecla "Anular zoom".</br></br>As curvas exibidas podem ser desativadas ou novamente ativadas na parte inferior (legenda). As curvas desativadas não são exibidas na documentação.',
            '利用“缩放”按键可以在“绝对值”和“相关值”之间切换。</br></br>可以通过“单击拖拽”放大显示的曲线。点击“激活移动”后，可以水平移动放大的区域。点击“激活放大”后可以再次放大。</br>要将放大操作复位，请点击“复位放大操作“ 。</br></br>可以在下方（图例）关闭或重新激活显示的曲线。关闭的曲线将不会在文档中显示。',
            'Derecelendirme tuşuyla "Mutlak değerler" ile "Alınan değerler" arasında geçiş yapılabilir.</br></br>Gösterilen eğriler "Tıklatma ve çekme" ile büyütülebilir. Büyütülen alan, "Kaydırmayı etkinleştir" tuşuna basıldıktan sonra yatay olarak kaydırılabilir. "Büyütmeyi etkinleştir" tuşuna basıldığında büyütme tekrar mümkün olur. </br>Büyütmeyi sıfırlamak için, lütfen "Büyütmeyi sıfırla" tuşuna basın.</br></br>Gösterilen eğriler alt kısmında (açıklama) devre dışı bırakılabilir veya tekrar etkinleştirilebilir. Devre dışı bırakılan eğriler dokümantasyonda gösterilmez.',
            'Met de toets “schaalwaarde bepalen” kan worden omgeschakeld tussen “absolute waarde” en “relatieve waarde”.</br></br>De aangeduide curven kunnen met “klikken en slepen” worden vergroot. Het vergrote bereik kan horizontaal worden verschoven nadat de toets “verschuiven activeren” werd ingedrukt. Vergroting wordt weer mogelijk als de toets “vergroting activeren” wordt ingedrukt. </br>Om de vergroting terug te zetten, op de toets “Vergroting terugzetten” drukken.</br></br>De aangeduide curven kunnen in het onderste deel (legende) worden gedeactiveerd of opnieuw worden geactiveerd. Gedeactiveerde curven worden in de documentatie niet aangeduid.',
            'Przyciskiem „Skalowanie” można przełączać między opcjami „Wartości bezwzględne” oraz „Wartości odnośne”.</br></br>Wyświetlone krzywe można powiększyć metodą „kliknij i przeciągnij”. Powiększony obszar można przesunąć w poziomie po naciśnięciu przycisku „Aktywuj przesunięcie”. Powiększenie będzie ponownie możliwe po naciśnięciu przycisku „Aktywuj powiększenie”. </br>Aby zresetować powiększenie, należy nacisnąć przycisk „Zresetuj powiększenie”.</br></br>Wyświetlone krzywe można deaktywować lub aktywować ponownie w dolnej części (legenda). Zdezaktywowane krzywe nie są wyświetlane w dokumentacji.',
            'Tlačítkem „Stupnice” lze přepínat mezi „Absolutními hodnotami“ a „Relativními hodnotami“.</br></br>Zobrazené křivky lze zvětšit „kliknutím a tažením“. Zvětšenou oblast lze po stisknutí tlačítka „Aktivovat posun“ posunout v horizontálním směru. Zvětšení je opět možné po stisknutí tlačítka „Aktivovat zvětšení“. </br>Chcete-li obnovit původní zvětšení, stiskněte tlačítko „Obnovit původní zvětšení“.</br></br>Zobrazené křivky lze deaktivovat nebo znovu aktivovat ve spodní části (vysvětlivky). Deaktivované křivky nebudou v dokumentaci zobrazeny.'
        ]
    },
    'header': {
        'support': {
            'label': [
                'Support',
                'Support',
                'Soporte y asistencia',
                'Support',
                'Supporto',
                'Apoio',
                '技术支持',
                'Destek',
                'Support',
                'Wsparcie techniczne',
                'Podpora'
            ],
            'report': [
                'Report a problem',
                'Ein Problem melden',
                'Notificar un problema',
                'Signaler un problème',
                'Segnalare un problema',
                'Comunicar um problema',
                '报告问题',
                'Bir sorun bildir',
                'Een probleem melden',
                'Zgłoś problem',
                'Ohlásit problém'
            ],
            'ebusiness': [
                'E-Business',
                'E-Business',
                'E-Business',
                'E-business',
                'E-Business',
                'E-Business',
                '电子商务',
                'eBusiness',
                'E-Business',
                'E-Business',
                'E-Business'
            ]
        },
        'language': [
            'Language',
            'Sprache',
            'Idioma',
            'Langue',
            'Lingua',
            'Língua',
            '语言',
            'Dil',
            'Taal',
            'Język',
            'Jazyk'
        ],
        'selectLanguage': [
            'Please select a language.',
            'Bitte Sprache auswählen',
            'Seleccionar idioma',
            'Sélectionner la langue',
            'Selezionare la lingua',
            'Selecionar idioma',
            '请选择语言',
            'Lütfen dil seçiniz',
            'Kies een taal',
            'Wybierz język',
            'Zvolte prosím jazyk'
        ],
        'languages': {
            'en': [
                'English',
                'Englisch',
                'Inglés',
                'Anglais',
                'Inglese',
                'Inglês',
                '英语',
                'İngilizce',
                'Engels',
                'Angielski',
                'Angličtina'
            ],
            'de': [
                'German',
                'Deutsch',
                'Alemán',
                'Allemand',
                'Tedesco',
                'Alemão',
                '德语',
                'Almanca',
                'Duits',
                'Niemiecki',
                'Němčina'
            ],
            'es': [
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish',
                'Spanish'
            ],
            'fr': [
                'French',
                'French',
                'French',
                'French',
                'French',
                'French',
                'French',
                'French',
                'French',
                'French',
                'French'
            ],
            'it': [
                'Italian',
                'Italian',
                'Italian',
                'Italian',
                'Italian',
                'Italian',
                'Italian',
                'Italian',
                'Italian',
                'Italian',
                'Italian'
            ],
            'pt': [
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese',
                'Portuguese'
            ],
            'cn': [
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese',
                'Chinese'
            ],
            'tr': [
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish',
                'Turkish'
            ],
            'nl': [
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch',
                'Dutch'
            ],
            'pl': [
                'Polish',
                'Polish',
                'Polish',
                'Polish',
                'Polish',
                'Polish',
                'Polish',
                'Polish',
                'Polish',
                'Polish',
                'Polish'
            ],
            'cs': [
                'Czech',
                'Czech',
                'Czech',
                'Czech',
                'Czech',
                'Czech',
                'Czech',
                'Czech',
                'Czech',
                'Czech',
                'Czech'
            ]
        },
        'search': [
            'Search for MLFB',
            'Suche nach MLFB',
            'Buscar referencia MLFB',
            'Recherche du numéro de référence',
            'Ricerca MLFB',
            'Pesquisa de MLFB',
            '搜索 MLFB',
            'MLFB ara',
            'Zoeken naar MLFB',
            'Szukaj MLFB',
            'Vyhledávání podle MLFB'
        ],
        'skipToMainContent': [
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content',
            'Skip to main content'
        ]
    }
});
